/* eslint-disable max-len */

import {FY} from '../../../../pages/esgManager/constants/FrameWorksConst';

// principle1----------------------------------
export const Principle1Key = {
  P1_QUESTION_1: 'p1Question1',
  P1_QUESTION_2: 'p1Question2',
  P1_QUESTION_3: 'p1Question3',
  P1_QUESTION_4: 'p1Question4',
  P1_QUESTION_5: 'p1Question5',
  P1_QUESTION_6: 'p1Question6',
  P1_QUESTION_7: 'p1Question7',
  P1_QUESTION_8: 'p1Question8',
  P1_QUESTION_9: 'p1Question9',
  P1_QUESTION_10: 'p1Question10',

  P1_QUESTION_11: 'p1Question11',
  P1_QUESTION_12: 'p1Question12',
  P1_QUESTION_13: 'p1Question13',
  P1_QUESTION_14: 'p1Question14',
  P1_QUESTION_15: 'p1Question15',
  P1_QUESTION_16: 'p1Question16',
  P1_QUESTION_17: 'p1Question17',
  P1_QUESTION_18: 'p1Question18',
  P1_QUESTION_19: 'p1Question19',
  P1_QUESTION_20: 'p1Question20',

  P1_QUESTION_21: 'p1Question21',
  P1_QUESTION_22: 'p1Question22',
  P1_QUESTION_23: 'p1Question23',
  P1_QUESTION_24: 'p1Question24',
  P1_QUESTION_25: 'p1Question25',
  P1_QUESTION_26: 'p1Question26',
  P1_QUESTION_27: 'p1Question27',
  P1_QUESTION_28: 'p1Question28',
  P1_QUESTION_29: 'p1Question29',
  P1_QUESTION_30: 'p1Question30',

  P1_QUESTION_31: 'p1Question31',
  P1_QUESTION_32: 'p1Question32',
  P1_QUESTION_33: 'p1Question33',
  P1_QUESTION_34: 'p1Question34',
  P1_QUESTION_35: 'p1Question35',
  P1_QUESTION_36: 'p1Question36',
  P1_QUESTION_37: 'p1Question37',
  P1_QUESTION_38: 'p1Question38',
  P1_QUESTION_39: 'p1Question39',
  P1_QUESTION_40: 'p1Question40',

  P1_QUESTION_41: 'p1Question41',
  P1_QUESTION_42: 'p1Question42',
  P1_QUESTION_43: 'p1Question43',
  P1_QUESTION_44: 'p1Question44',
  P1_QUESTION_45: 'p1Question45',
  P1_QUESTION_46: 'p1Question46',
  P1_QUESTION_47: 'p1Question47',
  P1_QUESTION_48: 'p1Question48',
  P1_QUESTION_49: 'p1Question49',
  P1_QUESTION_50: 'p1Question50',

  P1_QUESTION_51: 'p1Question51',
  P1_QUESTION_52: 'p1Question52',
  P1_QUESTION_53: 'p1Question53',
  P1_QUESTION_54: 'p1Question54',
  P1_QUESTION_55: 'p1Question55',
  P1_QUESTION_56: 'p1Question56',
  P1_QUESTION_56_1: 'p1Question56_1',
  P1_QUESTION_56_2: 'p1Question56_2',
  P1_QUESTION_57: 'p1Question57',
  P1_QUESTION_58: 'p1Question58',
  P1_QUESTION_59: 'p1Question59',
  P1_QUESTION_60: 'p1Question60',

  P1_QUESTION_61: 'p1Question61',
  P1_QUESTION_62: 'p1Question62',
  P1_QUESTION_63: 'p1Question63',
  P1_QUESTION_64: 'p1Question64',
  P1_QUESTION_65: 'p1Question65',
  P1_QUESTION_66: 'p1Question66',
  P1_QUESTION_67: 'p1Question67',
  P1_QUESTION_68: 'p1Question68',
  P1_QUESTION_69: 'p1Question69',
  P1_QUESTION_70: 'p1Question70',

  P1_QUESTION_71: 'p1Question71',
  P1_QUESTION_72: 'p1Question72',
  P1_QUESTION_73: 'p1Question73',
  P1_QUESTION_74: 'p1Question74',
  P1_QUESTION_75: 'p1Question75',
  P1_QUESTION_76: 'p1Question76',
  P1_QUESTION_77: 'p1Question77',
  P1_QUESTION_78: 'p1Question78',
  P1_QUESTION_79: 'p1Question79',
  P1_QUESTION_80: 'p1Question80',

  P1_QUESTION_81: 'p1Question81',
  P1_QUESTION_82: 'p1Question82',
  P1_QUESTION_83: 'p1Question83',
  P1_QUESTION_84: 'p1Question84',
  P1_QUESTION_85: 'p1Question85',
  P1_QUESTION_86: 'p1Question86',
  P1_QUESTION_87: 'p1Question87',
  P1_QUESTION_88: 'p1Question88',
  P1_QUESTION_89: 'p1Question89',
  P1_QUESTION_90: 'p1Question90',

  P1_QUESTION_91: 'p1Question91'
};

export const Principle1Label = {
  P1_HEADINGLABEL_1: 'Essential Indicators',
  P1_HEADINGLABEL_2: 'Leadership Indicators',

  P1_QUESTION_1:
    '1. Percentage coverage by training and awareness programmes on any of the Principles during the financial year:',
  P1_QUESTION_2:
    '2. Details of fines / penalties /punishment/ award/ compounding fees/ settlement amount id  in  proceedings  (by  the  entity  or  by  directors  /  KMPs)  with  regulators/  law enforcement agencies/ judicial institutions, in the financial year, in the following format (Note: the entity shall make disclosures on the basis of materiality as specified in Regulation 30  of SEBI (Listing Obligations and Disclosure Obligations) Regulations, 2015 and as disclosed on the entity’s website):',
  P1_QUESTION_3:
    '3. Of the instances disclosed in Question 2 above, details of the Appeal / Revision preferred in cases where monetary or non-monetary action has been appealed.',
  P1_QUESTION_4:
    '4. Does the entity have an anti-corruption or anti-bribery policy? If yes, provide details in brief and if available, provide a web-link to the policy.',
  P1_QUESTION_5:
    '5. Number of Directors/KMPs/employees/workers against whom disciplinary action was taken by any law enforcement agency for the charges of bribery/ corruption:',
  P1_QUESTION_6:
    '6. Details of complaints with regard to conflict of interest:',
  P1_QUESTION_7:
    '7. Provide details of any corrective action taken or underway on issues related to fines / penalties / action taken by regulators/ law enforcement agencies/ judicial institutions, on cases of corruption and conflicts of interest.',
  P1_QUESTION_8:
    '8. Number of days of accounts payables ((Accounts payable *365) / Cost of goods/services procured) in the following format:',
  P1_QUESTION_9:
    '9. Open-ness of business (Provide details of concentration of purchases and sales with trading houses, dealers, and related parties along-with loans and advances & investments, with related parties, in the following format):',

  P1_QUESTION_10:
    '1. Awareness programmes conducted for value chain partners  on any  of  the Principles during the financial year:',
  P1_QUESTION_11:
    '2. Does the entity have processes in place to avoid/ manage conflict of interests involving members of the Board? (Yes/No)  If Yes, provide details of the same.',

  P1_HEADING_1: 'a. Board of Directors',
  P1_HEADING_2: 'b. Key Managerial Personnel',
  P1_HEADING_3: 'c. Employees other than BoD and KMPs',
  P1_HEADING_4: 'd. Workers',
  P1_HEADING_5: 'Monetary',
  P1_HEADING_6: 'a. Penalty / Fine',
  P1_HEADING_7: 'b. Settlement',
  P1_HEADING_8: 'c. Compounding fee',
  P1_HEADING_9: 'Non-Monetary',
  P1_HEADING_10: 'a. Imprisonment',
  P1_HEADING_11: 'b. Punishment',
  P1_HEADING_12: 'a. Directors',
  P1_HEADING_13: 'b. KMPs',
  P1_HEADING_14: 'c. Employees',
  P1_HEADING_15: 'd. Workers',
  P1_HEADING_16:
    'a. Number of complaints received in relation to issues of Conflict of Interest of the Directors',
  P1_HEADING_17:
    'b. Number of complaints received in relation to issues of Conflict of Interest of the KMPs',
  P1_HEADING_18: `In ( ${FY.current} )`,
  P1_HEADING_19: `In ( ${FY.previous} )`,

  P1_HEADING_20: 'Concentration of Purchases',
  P1_HEADING_21: 'Concentration of Sales',
  P1_HEADING_22: 'Share of RPTs in',
  P1_HEADING_23: 'a. Purchases from trading houses as % of total  purchases',
  P1_HEADING_24: 'b. Number of trading houses where purchases are made from',
  P1_HEADING_25:
    'c. Purchases from top 10 trading houses as % of total purchases from trading houses',
  P1_HEADING_26: 'a. Sales to dealers / distributors as % of total sales ',
  P1_HEADING_27: 'b. Number of dealers / distributors to whom sales are made',
  P1_HEADING_28:
    'c. Sales to top 10 dealers / distributors as % of total sales to dealers / distributors',
  P1_HEADING_29:
    'a. Purchases (Purchases with related parties / Total Purchases)',
  P1_HEADING_30: 'b. Sales (Sales to related parties / Total Sales)',
  P1_HEADING_31:
    'c. Loans & advances (Loans & advances given to related parties / Total loans & advances)',
  P1_HEADING_32:
    'd. Investments ( Investments in related parties / Total Investments made)',
  P1_HEADING_33:
    'Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable.',
  P1_HEADING_34: 'Essential Indicators',
  P1_HEADING_35: 'Leadership Indicators',
  P1_HEADING_36: 'Number of days of accounts payables',
  P1_LABEL_1: 'Total number of training and awareness programmes held',
  P1_LABEL_2: 'Topics / principles covered under the training and its impact',
  P1_LABEL_3:
    '% age of persons in respective category covered by the awareness programmes',

  P1_LABEL_4: 'NGRBC Principle',
  P1_LABEL_5:
    'Name of the regulatory/ enforcement agencies / judicial institutions',
  P1_LABEL_6: 'Amount (In INR)',
  P1_LABEL_7: 'Brief of the Case',
  P1_LABEL_8: 'Has an appeal been preferred? (Yes/No)',
  P1_LABEL_9: 'NGRBC Principle',
  P1_LABEL_10:
    'Name of the regulatory/ enforcement agencies/ judicial institutions',
  P1_LABEL_11: 'Brief of the Case',
  P1_LABEL_12: 'Has an appeal been preferred? (Yes/No)',
  P1_LABEL_13: 'Case Details',
  P1_LABEL_14:
    'Name of the regulatory / enforcement agencies / judicial institutions',
  P1_LABEL_15: `FY ( ${FY.current} )`,
  P1_LABEL_16: `FY ( ${FY.previous} )`,
  P1_LABEL_17: 'Number',
  P1_LABEL_18: 'Remarks',
  P1_LABEL_19: 'Total number of awareness programmes held',
  P1_LABEL_20: 'Topics / principles covered under the training',
  P1_LABEL_21:
    '% age of value chain partners covered (by value of business done with such partners) under the awareness programmes'
};

// principle2----------------------------------
export const Principle2Key = {
  P2_QUESTION_1: 'p2Question1',
  P2_QUESTION_2: 'p2Question2',
  P2_QUESTION_3: 'p2Question3',
  P2_QUESTION_4: 'p2Question4',
  P2_QUESTION_5: 'p2Question5',
  P2_QUESTION_6: 'p2Question6',
  P2_QUESTION_7: 'p2Question7',
  P2_QUESTION_7_yes: 'p2Question7_yes',
  P2_QUESTION_8: 'p2Question8',
  P2_QUESTION_9: 'p2Question9',

  P2_QUESTION_10: 'p2Question10',
  P2_QUESTION_11: 'p2Question11',
  P2_QUESTION_12: 'p2Question12',
  P2_QUESTION_13: 'p2Question13',
  P2_QUESTION_14: 'p2Question14',
  P2_QUESTION_14_1: 'p2Question14_1',
  P2_QUESTION_15: 'p2Question15',
  P2_QUESTION_16: 'p2Question16',
  P2_QUESTION_17: 'p2Question17',
  P2_QUESTION_18: 'p2Question18',
  P2_QUESTION_19: 'p2Question19',
  P2_QUESTION_20: 'p2Question20',

  P2_QUESTION_21: 'p2Question21',
  P2_QUESTION_22: 'p2Question22',
  P2_QUESTION_23: 'p2Question23',
  P2_QUESTION_24: 'p2Question24',
  P2_QUESTION_25: 'p2Question25',
  P2_QUESTION_26: 'p2Question26',
  P2_QUESTION_27: 'p2Question27',
  P2_QUESTION_28: 'p2Question28',
  P2_QUESTION_29: 'p2Question29',
  P2_QUESTION_30: 'p2Question30',

  P2_QUESTION_31: 'p2Question31',
  P2_QUESTION_32: 'p2Question32',
  P2_QUESTION_33: 'p2Question33',
  P2_QUESTION_34: 'p2Question34',
  P2_QUESTION_35: 'p2Question35',
  P2_QUESTION_36: 'p2Question36',
  P2_QUESTION_37: 'p2Question37',
  P2_QUESTION_38: 'p2Question38',
  P2_QUESTION_39: 'p2Question39',
  P2_QUESTION_40: 'p2Question40',

  P2_QUESTION_41: 'p2Question41',
  P2_QUESTION_42: 'p2Question42',
  P2_QUESTION_43: 'p2Question43',
  P2_QUESTION_44: 'p2Question44',
  P2_QUESTION_45: 'p2Question45',
  P2_QUESTION_46: 'p2Question46',
  P2_QUESTION_47: 'p2Question47',
  P2_QUESTION_48: 'p2Question48',
  P2_QUESTION_49: 'p2Question49',
  P2_QUESTION_50: 'p2Question50',

  P2_QUESTION_51: 'p2Question51',
  P2_QUESTION_52: 'p2Question52',
  P2_QUESTION_53: 'p2Question53',
  P2_QUESTION_54: 'p2Question54',
  P2_QUESTION_55: 'p2Question55',
  P2_QUESTION_56: 'p2Question56',
  P2_QUESTION_57: 'p2Question57',
  P2_QUESTION_58: 'p2Question58',
  P2_QUESTION_59: 'p2Question59',
  P2_QUESTION_60: 'p2Question60',

  P2_QUESTION_61: 'p2Question61',
  P2_QUESTION_62: 'p2Question62',
  P2_QUESTION_63: 'p2Question63',
  P2_QUESTION_63_1: 'p2Question63_1'
};

export const Principle2Label = {
  P2_HEADINGLABEL_1: 'Essential Indicators',
  P2_HEADINGLABEL_2: 'Leadership Indicators',

  P2_QUESTION_1:
    '1. Percentage of R&D and capital expenditure (capex) investments in specific technologies to improve the environmental and social impacts of product and processes to total R&D and capex investments made by the entity, respectively.',
  P2_QUESTION_2:
    '2. a. Does the entity have procedures in place for sustainable sourcing? (Yes/No):',
  P2_QUESTION_3:
    '3. Describe the processes in place to safely reclaim your products for reusing, recycling and disposing at the end of life, for:',
  P2_QUESTION_4:
    '4. Whether Extended Producer Responsibility (EPR) is applicable to the entity’s activities (Yes / No). If yes, whether the waste collection plan is in line with the Extended Producer Responsibility (EPR) plan submitted to Pollution Control Boards? If not, provide steps taken to address the same:',
  P2_QUESTION_5:
    '1. Has the entity conducted Life Cycle Perspective / Assessments (LCA) for any of its products (for manufacturing industry) or for its services (for service industry)? If yes, provide details in the following format?',
  P2_QUESTION_6:
    '2. If there are any significant social or environmental concerns and/or risks arising from production or disposal of your products / services, as identified in the Life Cycle  Perspective / Assessments (LCA) or through any other means, briefly describe the same along-with action taken to mitigate the same.',
  P2_QUESTION_7:
    '3. Percentage of recycled or reused input material to total material (by value) used in production (for manufacturing industry) or providing services (for service industry).',

  P2_QUESTION_8:
    '4. Of the products and packaging reclaimed at end of life of products, amount (in metric tonnes) reused, recycled, and safely disposed, as per the following format:',
  P2_QUESTION_9:
    '5. Reclaimed products and their packaging materials (as percentage of products sold) for each product category.',

  P2_HEADING_1:
    'Businesses should provide goods and services in a manner that is sustainable and safe',
  P2_HEADING_4: 'a. R&D',
  P2_HEADING_5: 'b. Capex',
  P2_HEADING_6: 'a. Plastics (including packaging) : ',
  P2_HEADING_7: 'b. E-waste : ',
  P2_HEADING_8: 'c. Hazardous waste : ',
  P2_HEADING_9: 'd. Other waste : ',
  P2_HEADING_10: 'NIC Code',
  P2_HEADING_11: 'Name of Product / Service',
  P2_HEADING_12: '% of total Turnover contributed',
  P2_HEADING_13:
    'Boundary for which the Life Cycle Perspective / Assessment was conducted',
  P2_HEADING_14: 'Whether conducted  by independent external agency (Yes/No)',
  P2_HEADING_15:
    'Results communicated in public domain (Yes/No) If yes, provide the web-link.',
  P2_HEADING_16: 'Name of Product / Service',
  P2_HEADING_17: 'Description of the risk / concern',
  P2_HEADING_18: 'Action Taken',
  P2_HEADING_19: 'Indicate input material',
  P2_HEADING_20: `Recycled or re-used input material to total material ( ${FY.current} )`,
  P2_HEADING_21: `Recycled or re-used input material to total material (${FY.previous})`,
  P2_HEADING_22: 'Plastics (including packaging)',
  P2_HEADING_23: 'E-waste',
  P2_HEADING_24: 'Hazardous waste',
  P2_HEADING_25: 'Other waste',
  P2_HEADING_26: 'Indicate product category',
  P2_HEADING_27:
    'Reclaimed products and their packaging materials as % of total products sold in respective category',
  P2_HEADING_29:
    'b. If yes, what percentage of inputs were sourced sustainably? : ',
  P2_LABEL_1: `In ( ${FY.current} )`,
  P2_LABEL_2: `In ( ${FY.previous} )`,
  P2_LABEL_3: 'Details of improvements in environmental and social impacts',
  P2_LABEL_4: 'Re-Used',
  P2_LABEL_5: 'Recycled',
  P2_LABEL_6: 'Safely Disposed'
};

// principle2----------------------------------
export const Principle3Key = {
  P3_QUESTION_1: 'p3Question1',
  P3_QUESTION_2: 'p3Question2',
  P3_QUESTION_3: 'p3Question3',
  P3_QUESTION_4: 'p3Question4',
  P3_QUESTION_5: 'p3Question5',
  P3_QUESTION_6: 'p3Question6',
  P3_QUESTION_7: 'p3Question7',
  P3_QUESTION_8: 'p3Question8',
  P3_QUESTION_9: 'p3Question9',

  P3_QUESTION_10: 'p3Question10',
  P3_QUESTION_11: 'p3Question11',
  P3_QUESTION_12: 'p3Question12',
  P3_QUESTION_13: 'p3Question13',
  P3_QUESTION_14: 'p3Question14',
  P3_QUESTION_15: 'p3Question15',
  P3_QUESTION_16: 'p3Question16',
  P3_QUESTION_17: 'p3Question17',
  P3_QUESTION_18: 'p3Question18',
  P3_QUESTION_19: 'p3Question19',
  P3_QUESTION_20: 'p3Question20',

  P3_QUESTION_21: 'p3Question21',
  P3_QUESTION_22: 'p3Question22',
  P3_QUESTION_23: 'p3Question23',
  P3_QUESTION_24: 'p3Question24',
  P3_QUESTION_25: 'p3Question25',
  P3_QUESTION_26: 'p3Question26',
  P3_QUESTION_27: 'p3Question27',
  P3_QUESTION_28: 'p3Question28',
  P3_QUESTION_29: 'p3Question29',
  P3_QUESTION_30: 'p3Question30',

  P3_QUESTION_31: 'p3Question31',
  P3_QUESTION_32: 'p3Question32',
  P3_QUESTION_33: 'p3Question33',
  P3_QUESTION_34: 'p3Question34',
  P3_QUESTION_35: 'p3Question35',
  P3_QUESTION_36: 'p3Question36',
  P3_QUESTION_37: 'p3Question37',
  P3_QUESTION_38: 'p3Question38',
  P3_QUESTION_39: 'p3Question39',
  P3_QUESTION_40: 'p3Question40',

  P3_QUESTION_41: 'p3Question41',
  P3_QUESTION_42: 'p3Question42',
  P3_QUESTION_43: 'p3Question43',
  P3_QUESTION_44: 'p3Question44',
  P3_QUESTION_45: 'p3Question45',
  P3_QUESTION_46: 'p3Question46',
  P3_QUESTION_47: 'p3Question47',
  P3_QUESTION_48: 'p3Question48',
  P3_QUESTION_49: 'p3Question49',
  P3_QUESTION_50: 'p3Question50',

  P3_QUESTION_51: 'p3Question51',
  P3_QUESTION_52: 'p3Question52',
  P3_QUESTION_53: 'p3Question53',
  P3_QUESTION_54: 'p3Question54',
  P3_QUESTION_55: 'p3Question55',
  P3_QUESTION_56: 'p3Question56',
  P3_QUESTION_57: 'p3Question57',
  P3_QUESTION_58: 'p3Question58',
  P3_QUESTION_59: 'p3Question59',
  P3_QUESTION_60: 'p3Question60',

  P3_QUESTION_61: 'p3Question61',
  P3_QUESTION_62: 'p3Question62',
  P3_QUESTION_63: 'p3Question63',
  P3_QUESTION_64: 'p3Question64',
  P3_QUESTION_65: 'p3Question65',
  P3_QUESTION_66: 'p3Question66',
  P3_QUESTION_67: 'p3Question67',
  P3_QUESTION_68: 'p3Question68',
  P3_QUESTION_69: 'p3Question69',
  P3_QUESTION_70: 'p3Question70',

  P3_QUESTION_71: 'p3Question71',
  P3_QUESTION_72: 'p3Question72',
  P3_QUESTION_73: 'p3Question73',
  P3_QUESTION_74: 'p3Question74',
  P3_QUESTION_75: 'p3Question75',
  P3_QUESTION_76: 'p3Question76',
  P3_QUESTION_77: 'p3Question77',
  P3_QUESTION_78: 'p3Question78',
  P3_QUESTION_79: 'p3Question79',
  P3_QUESTION_80: 'p3Question80',

  P3_QUESTION_81: 'p3Question81',
  P3_QUESTION_82: 'p3Question82',
  P3_QUESTION_83: 'p3Question83',
  P3_QUESTION_84: 'p3Question84',
  P3_QUESTION_85: 'p3Question85',
  P3_QUESTION_86: 'p3Question86',
  P3_QUESTION_87: 'p3Question87',
  P3_QUESTION_88: 'p3Question88',
  P3_QUESTION_89: 'p3Question89',
  P3_QUESTION_90: 'p3Question90',

  P3_QUESTION_91: 'p3Question91',
  P3_QUESTION_92: 'p3Question92',
  P3_QUESTION_93: 'p3Question93',
  P3_QUESTION_94: 'p3Question94',
  P3_QUESTION_95: 'p3Question95',
  P3_QUESTION_96: 'p3Question96',
  P3_QUESTION_97: 'p3Question97',
  P3_QUESTION_98: 'p3Question98',
  P3_QUESTION_99: 'p3Question99',
  P3_QUESTION_100: 'p3Question100',

  P3_QUESTION_101: 'p3Question101',
  P3_QUESTION_102: 'p3Question102',
  P3_QUESTION_103: 'p3Question103',
  P3_QUESTION_103_1: 'p3Question103_1',
  P3_QUESTION_104: 'p3Question104',
  P3_QUESTION_105: 'p3Question105',
  P3_QUESTION_106: 'p3Question106',
  P3_QUESTION_107: 'p3Question107',
  P3_QUESTION_108: 'p3Question108',
  P3_QUESTION_109: 'p3Question109',
  P3_QUESTION_110: 'p3Question110',

  P3_QUESTION_111: 'p3Question111',
  P3_QUESTION_112: 'p3Question112',
  P3_QUESTION_113: 'p3Question113',
  P3_QUESTION_114: 'p3Question114',
  P3_QUESTION_115: 'p3Question115',
  P3_QUESTION_116: 'p3Question116',
  P3_QUESTION_117: 'p3Question117',
  P3_QUESTION_118: 'p3Question118',
  P3_QUESTION_119: 'p3Question119',
  P3_QUESTION_120: 'p3Question120',

  P3_QUESTION_121: 'p3Question121',
  P3_QUESTION_122: 'p3Question122',
  P3_QUESTION_123: 'p3Question123',
  P3_QUESTION_124: 'p3Question124',
  P3_QUESTION_125: 'p3Question125',
  P3_QUESTION_126: 'p3Question126',
  P3_QUESTION_127: 'p3Question127',
  P3_QUESTION_128: 'p3Question128',
  P3_QUESTION_129: 'p3Question129',
  P3_QUESTION_130: 'p3Question130',

  P3_QUESTION_131: 'p3Question131',
  P3_QUESTION_132: 'p3Question132',
  P3_QUESTION_133: 'p3Question133',
  P3_QUESTION_134: 'p3Question134',
  P3_QUESTION_135: 'p3Question135',
  P3_QUESTION_136: 'p3Question136',
  P3_QUESTION_137: 'p3Question137',
  P3_QUESTION_138: 'p3Question138',
  P3_QUESTION_139: 'p3Question139',
  P3_QUESTION_140: 'p3Question140',

  P3_QUESTION_141: 'p3Question141',
  P3_QUESTION_142: 'p3Question142',
  P3_QUESTION_143: 'p3Question143',
  P3_QUESTION_144: 'p3Question144',
  P3_QUESTION_145: 'p3Question145',
  P3_QUESTION_146: 'p3Question146',
  P3_QUESTION_147: 'p3Question147',
  P3_QUESTION_148: 'p3Question148',
  P3_QUESTION_149: 'p3Question149',
  P3_QUESTION_150: 'p3Question150',

  P3_QUESTION_151: 'p3Question151',
  P3_QUESTION_152: 'p3Question152',
  P3_QUESTION_153: 'p3Question153',
  P3_QUESTION_154: 'p3Question154',
  P3_QUESTION_155: 'p3Question155',
  P3_QUESTION_156: 'p3Question156',
  P3_QUESTION_157: 'p3Question157',
  P3_QUESTION_158: 'p3Question158',
  P3_QUESTION_158_1: 'p3Question158_1',
  P3_QUESTION_159: 'p3Question159',
  P3_QUESTION_160: 'p3Question160',

  P3_QUESTION_161: 'p3Question161',
  P3_QUESTION_162: 'p3Question162',
  P3_QUESTION_163: 'p3Question163',
  P3_QUESTION_164: 'p3Question164',
  P3_QUESTION_165: 'p3Question165',
  P3_QUESTION_166: 'p3Question166',
  P3_QUESTION_167: 'p3Question167',
  P3_QUESTION_168: 'p3Question168',
  P3_QUESTION_169: 'p3Question169',
  P3_QUESTION_170: 'p3Question170',

  P3_QUESTION_171: 'p3Question171',
  P3_QUESTION_172: 'p3Question172',
  P3_QUESTION_173: 'p3Question173',
  P3_QUESTION_174: 'p3Question174',
  P3_QUESTION_175: 'p3Question175',
  P3_QUESTION_176: 'p3Question176',
  P3_QUESTION_177: 'p3Question177',
  P3_QUESTION_178: 'p3Question178',
  P3_QUESTION_179: 'p3Question179',
  P3_QUESTION_180: 'p3Question180',

  P3_QUESTION_181: 'p3Question181',
  P3_QUESTION_182: 'p3Question182',
  P3_QUESTION_183: 'p3Question183',
  P3_QUESTION_184: 'p3Question184',
  P3_QUESTION_185: 'p3Question185',
  P3_QUESTION_186: 'p3Question186',
  P3_QUESTION_187: 'p3Question187',
  P3_QUESTION_188: 'p3Question188',
  P3_QUESTION_189: 'p3Question189',
  P3_QUESTION_190: 'p3Question190',

  P3_QUESTION_191: 'p3Question191',
  P3_QUESTION_192: 'p3Question192',
  P3_QUESTION_193: 'p3Question193',
  P3_QUESTION_194: 'p3Question194',
  P3_QUESTION_195: 'p3Question195',
  P3_QUESTION_196: 'p3Question196',
  P3_QUESTION_197: 'p3Question197',
  P3_QUESTION_198: 'p3Question198',
  P3_QUESTION_199: 'p3Question199',
  P3_QUESTION_200: 'p3Question200',

  P3_QUESTION_201: 'p3Question201',
  P3_QUESTION_202: 'p3Question202',
  P3_QUESTION_203: 'p3Question203',
  P3_QUESTION_204: 'p3Question204',
  P3_QUESTION_205: 'p3Question205',
  P3_QUESTION_206: 'p3Question206',
  P3_QUESTION_207: 'p3Question207',
  P3_QUESTION_208: 'p3Question208',
  P3_QUESTION_209: 'p3Question209',
  P3_QUESTION_210: 'p3Question210',

  P3_QUESTION_211: 'p3Question211',
  P3_QUESTION_212: 'p3Question212',
  P3_QUESTION_213: 'p3Question213',
  P3_QUESTION_214: 'p3Question214',
  P3_QUESTION_215: 'p3Question215',
  P3_QUESTION_216: 'p3Question216',
  P3_QUESTION_217: 'p3Question217',
  P3_QUESTION_218: 'p3Question218',
  P3_QUESTION_219: 'p3Question219',
  P3_QUESTION_220: 'p3Question220',

  P3_QUESTION_221: 'p3Question221',
  P3_QUESTION_221_1: 'p3Question221_1',
  P3_QUESTION_222: 'p3Question222',
  P3_QUESTION_222_1: 'p3Question222_1',
  P3_QUESTION_223: 'p3Question223',
  P3_QUESTION_223_1: 'p3Question223_1',
  P3_QUESTION_224: 'p3Question224',
  P3_QUESTION_224_1: 'p3Question224_1',
  P3_QUESTION_225: 'p3Question225',
  P3_QUESTION_225_1: 'p3Question225_1',
  P3_QUESTION_226: 'p3Question226',
  P3_QUESTION_226_1: 'p3Question226_1',
  P3_QUESTION_227: 'p3Question227',
  P3_QUESTION_227_1: 'p3Question227_1',
  P3_QUESTION_228: 'p3Question228',
  P3_QUESTION_228_1: 'p3Question228_1',
  P3_QUESTION_229: 'p3Question229',
  P3_QUESTION_229_1: 'p3Question229_1',
  P3_QUESTION_230: 'p3Question230',
  P3_QUESTION_230_1: 'p3Question230_1',

  P3_QUESTION_231: 'p3Question231',
  P3_QUESTION_232: 'p3Question232',
  P3_QUESTION_233: 'p3Question233',
  P3_QUESTION_234: 'p3Question234',
  P3_QUESTION_235: 'p3Question235',
  P3_QUESTION_236: 'p3Question236',
  P3_QUESTION_237: 'p3Question237',
  P3_QUESTION_238: 'p3Question238',
  P3_QUESTION_239: 'p3Question239',
  P3_QUESTION_240: 'p3Question240',

  P3_QUESTION_241: 'p3Question241',
  P3_QUESTION_242: 'p3Question242',
  P3_QUESTION_243: 'p3Question243',
  P3_QUESTION_244: 'p3Question244',
  P3_QUESTION_245: 'p3Question245',
  P3_QUESTION_246: 'p3Question246',
  P3_QUESTION_247: 'p3Question247',
  P3_QUESTION_248: 'p3Question248',
  P3_QUESTION_249: 'p3Question249',
  P3_QUESTION_250: 'p3Question250',

  P3_QUESTION_251: 'p3Question251',
  P3_QUESTION_252: 'p3Question252',
  P3_QUESTION_253: 'p3Question253',
  P3_QUESTION_254: 'p3Question254',
  P3_QUESTION_255: 'p3Question255',
  P3_QUESTION_256: 'p3Question256',
  P3_QUESTION_257: 'p3Question257',
  P3_QUESTION_258: 'p3Question258',
  P3_QUESTION_259: 'p3Question259',
  P3_QUESTION_260: 'p3Question260',

  P3_QUESTION_261: 'p3Question261',
  P3_QUESTION_262: 'p3Question262',
  P3_QUESTION_263: 'p3Question263',
  P3_QUESTION_264: 'p3Question264',
  P3_QUESTION_265: 'p3Question265',
  P3_QUESTION_266: 'p3Question266',
  P3_QUESTION_267: 'p3Question267',
  P3_QUESTION_268: 'p3Question268',
  P3_QUESTION_269: 'p3Question269',
  P3_QUESTION_270: 'p3Question270',

  P3_QUESTION_271: 'p3Question271',
  P3_QUESTION_272: 'p3Question272',
  P3_QUESTION_273: 'p3Question273',
  P3_QUESTION_274: 'p3Question274',
  P3_QUESTION_275: 'p3Question275',
  P3_QUESTION_276: 'p3Question276',
  P3_QUESTION_277: 'p3Question277',
  P3_QUESTION_278: 'p3Question278',
  P3_QUESTION_279: 'p3Question279',
  P3_QUESTION_280: 'p3Question280',

  P3_QUESTION_281: 'p3Question281',
  P3_QUESTION_282: 'p3Question282',
  P3_QUESTION_283: 'p3Question283',
  P3_QUESTION_284: 'p3Question284',
  P3_QUESTION_285: 'p3Question285',
  P3_QUESTION_286: 'p3Question286',
  P3_QUESTION_287: 'p3Question287',
  P3_QUESTION_288: 'p3Question288',
  P3_QUESTION_289: 'p3Question289',
  P3_QUESTION_290: 'p3Question290',

  P3_QUESTION_291: 'p3Question291',
  P3_QUESTION_292: 'p3Question292',
  P3_QUESTION_293: 'p3Question293',
  P3_QUESTION_294: 'p3Question294',
  P3_QUESTION_295: 'p3Question295',
  P3_QUESTION_296: 'p3Question296',
  P3_QUESTION_297: 'p3Question297',
  P3_QUESTION_298: 'p3Question298',
  P3_QUESTION_299: 'p3Question299',
  P3_QUESTION_300: 'p3Question300',

  P3_QUESTION_301: 'p3Question301',
  P3_QUESTION_302: 'p3Question302',
  P3_QUESTION_303: 'p3Question303',
  P3_QUESTION_304: 'p3Question304',
  P3_QUESTION_305: 'p3Question305',
  P3_QUESTION_306: 'p3Question306',
  P3_QUESTION_307: 'p3Question307',
  P3_QUESTION_308: 'p3Question308',
  P3_QUESTION_309: 'p3Question309',
  P3_QUESTION_310: 'p3Question310',

  P3_QUESTION_311: 'p3Question311',
  P3_QUESTION_312: 'p3Question312',
  P3_QUESTION_313: 'p3Question313',
  P3_QUESTION_314: 'p3Question314',
  P3_QUESTION_315: 'p3Question315',
  P3_QUESTION_316: 'p3Question316',
  P3_QUESTION_317: 'p3Question317',
  P3_QUESTION_318: 'p3Question318',
  P3_QUESTION_319: 'p3Question319',
  P3_QUESTION_320: 'p3Question320',

  P3_QUESTION_321: 'p3Question321',
  P3_QUESTION_322: 'p3Question322',
  P3_QUESTION_323: 'p3Question323',
  P3_QUESTION_324: 'p3Question324',
  P3_QUESTION_325: 'p3Question325',
  P3_QUESTION_326: 'p3Question326',
  P3_QUESTION_327: 'p3Question327',
  P3_QUESTION_328: 'p3Question328',
  P3_QUESTION_329: 'p3Question329',
  P3_QUESTION_330: 'p3Question330',

  P3_QUESTION_331: 'p3Question331',
  P3_QUESTION_332: 'p3Question332',
  P3_QUESTION_333: 'p3Question333',
  P3_QUESTION_334: 'p3Question334',
  P3_QUESTION_335: 'p3Question335',
  P3_QUESTION_336: 'p3Question336',
  P3_QUESTION_337: 'p3Question337',
  P3_QUESTION_338: 'p3Question338',
  P3_QUESTION_339: 'p3Question339',
  P3_QUESTION_340: 'p3Question340',

  P3_QUESTION_341: 'p3Question341',
  P3_QUESTION_342: 'p3Question342',
  P3_QUESTION_343: 'p3Question343',
  P3_QUESTION_344: 'p3Question344',
  P3_QUESTION_345: 'p3Question345',
  P3_QUESTION_346: 'p3Question346',
  P3_QUESTION_347: 'p3Question347',
  P3_QUESTION_348: 'p3Question348',
  P3_QUESTION_349: 'p3Question349',
  P3_QUESTION_350: 'p3Question350',

  P3_QUESTION_351: 'p3Question351',
  P3_QUESTION_352: 'p3Question352',
  P3_QUESTION_353: 'p3Question353',
  P3_QUESTION_354: 'p3Question354',
  P3_QUESTION_355: 'p3Question355',
  P3_QUESTION_356: 'p3Question356',
  P3_QUESTION_357: 'p3Question357',
  P3_QUESTION_358: 'p3Question358',
  P3_QUESTION_359: 'p3Question359',
  P3_QUESTION_360: 'p3Question360',
  P3_QUESTION_361: 'p3Question361',
  P3_QUESTION_362: 'p3Question362',
  P3_QUESTION_363: 'p3Question363',
  P3_QUESTION_364: 'p3Question364',
  P3_QUESTION_365: 'p3Question365',
  P3_QUESTION_366: 'p3Question366',
  P3_QUESTION_367: 'p3Question367',
  P3_QUESTION_368: 'p3Question368',
  P3_QUESTION_369: 'p3Question369',
  P3_QUESTION_370: 'p3Question370',
  P3_QUESTION_371: 'p3Question371',
  P3_QUESTION_372: 'p3Question372',
  P3_QUESTION_373: 'p3Question373',
  P3_QUESTION_374: 'p3Question374',
  P3_QUESTION_375: 'p3Question375',
  P3_QUESTION_376: 'p3Question376',
  P3_QUESTION_377: 'p3Question377',
  P3_QUESTION_378: 'p3Question378',
  P3_QUESTION_379: 'p3Question379',
  P3_QUESTION_380: 'p3Question380',
  P3_QUESTION_381: 'p3Question381',
  P3_QUESTION_382: 'p3Question382',
  P3_QUESTION_383: 'p3Question383',
  P3_QUESTION_384: 'p3Question384',
  P3_QUESTION_385: 'p3Question385',
  P3_QUESTION_386: 'p3Question386',
  P3_QUESTION_387: 'p3Question387',
  P3_QUESTION_388: 'p3Question388',
  P3_QUESTION_389: 'p3Question389',
  P3_QUESTION_390: 'p3Question390',
  P3_QUESTION_391: 'p3Question391',
  P3_QUESTION_392: 'p3Question392',
  P3_QUESTION_393: 'p3Question393',
  P3_QUESTION_394: 'p3Question394',
  P3_QUESTION_395: 'p3Question395',
  P3_QUESTION_396: 'p3Question396',
  P3_QUESTION_397: 'p3Question397',
  P3_QUESTION_398: 'p3Question398',
  P3_QUESTION_399: 'p3Question399',
  P3_QUESTION_400: 'p3Question400',
  P3_QUESTION_401: 'p3Question401',
  P3_QUESTION_402: 'p3Question402',
  P3_QUESTION_403: 'p3Question403',
  P3_QUESTION_404: 'p3Question404',
  P3_QUESTION_405: 'p3Question405',
  P3_QUESTION_406: 'p3Question406',
  P3_QUESTION_407: 'p3Question407',
  P3_QUESTION_408: 'p3Question408',
  P3_QUESTION_409: 'p3Question409',
  P3_QUESTION_410: 'p3Question410',
  P3_QUESTION_411: 'p3Question411',
  P3_QUESTION_412: 'p3Question412',
  P3_QUESTION_413: 'p3Question413',
  P3_QUESTION_414: 'p3Question414',
  P3_QUESTION_415: 'p3Question415',
  P3_QUESTION_416: 'p3Question416',
  P3_QUESTION_417: 'p3Question417',
  P3_QUESTION_418: 'p3Question418',
  P3_QUESTION_419: 'p3Question419',
  P3_QUESTION_420: 'p3Question420',
  P3_QUESTION_421: 'p3Question421',
  P3_QUESTION_422: 'p3Question422',
  P3_QUESTION_423: 'p3Question423',
  P3_QUESTION_424: 'p3Question424',
  P3_QUESTION_425: 'p3Question425',
  P3_QUESTION_426: 'p3Question426',
  P3_QUESTION_427: 'p3Question427',
  P3_QUESTION_428: 'p3Question428',
  P3_QUESTION_429: 'p3Question429',
  P3_QUESTION_430: 'p3Question430',
  P3_QUESTION_431: 'p3Question431',
  P3_QUESTION_432: 'p3Question432',
  P3_QUESTION_433: 'p3Question433',
  P3_QUESTION_434: 'p3Question434',
  P3_QUESTION_435: 'p3Question435',
  P3_QUESTION_436: 'p3Question436',
  P3_QUESTION_437: 'p3Question437',
  P3_QUESTION_438: 'p3Question438',
  P3_QUESTION_439: 'p3Question439',
  P3_QUESTION_440: 'p3Question440',
  P3_QUESTION_441: 'p3Question441',
  P3_QUESTION_442: 'p3Question442',
  P3_QUESTION_443: 'p3Question443',
  P3_QUESTION_444: 'p3Question444',
  P3_QUESTION_445: 'p3Question445',
  P3_QUESTION_446: 'p3Question446',
  P3_QUESTION_447: 'p3Question447',
  P3_QUESTION_448: 'p3Question448',
  P3_QUESTION_449: 'p3Question449',
  P3_QUESTION_450: 'p3Question450',
  P3_QUESTION_451: 'p3Question451',
  P3_QUESTION_452: 'p3Question452',
  P3_QUESTION_453: 'p3Question453',
  P3_QUESTION_454: 'p3Question454',
  P3_QUESTION_455: 'p3Question455',
  P3_QUESTION_456: 'p3Question456',
  P3_QUESTION_457: 'p3Question457',
  P3_QUESTION_458: 'p3Question458',
  P3_QUESTION_459: 'p3Question459',
  P3_QUESTION_460: 'p3Question460',
  P3_QUESTION_461: 'p3Question461',
  P3_QUESTION_462: 'p3Question462',
  P3_QUESTION_463: 'p3Question463',
  P3_QUESTION_464: 'p3Question464'
};

export const Principle3Label = {
  P3_HEADING_111:
    'Businesses should respect and promote the well-being  of all employees, including those in their value chains',
  P3_HEADINGLABEL_1: 'Essential Indicators',
  P3_HEADINGLABEL_2: 'Leadership Indicators',

  P3_HEADING_1: '1. a. Details of measures for the well-being of employees:',
  P3_HEADING_2: 'Permanent Employees',
  P3_HEADING_3: 'Other than Permanent Employees',
  P3_HEADING_4: 'b. Details of measures for the well-being of workers:',
  P3_HEADING_5: 'Permanent Workers',
  P3_HEADING_6: 'Other than Permanent Workers',
  P3_HEADING_7:
    'c. Spending on measures towards well-being of employees and workers (including permanent and other than permanent) in the following format –',
  P3_HEADING_8:
    'Cost incurred on well being measures as a % of total revenue of the company',
  P3_HEADING_9: `2. Details of retirement benefits, for ${FY.current} and ${FY.previous}.`,
  P3_HEADING_12: 'Benefits',
  P3_HEADING_13: 'a. PF',
  P3_HEADING_14: 'b. Gratuity',
  P3_HEADING_15: 'c. ESI',
  P3_HEADING_16: `${FY.current}`,
  P3_HEADING_17: `${FY.previous}`,
  P3_HEADING_18: 'd. Others please specify',
  P3_HEADING_19: 'Accessibility of workplaces',

  P3_HEADING_20: 'Permanent employees',
  P3_HEADING_21: 'Permanent workers',
  P3_HEADING_22: 'Total Other than Permanent Employees',
  P3_HEADING_23: 'Total Other than Permanent Workers',
  P3_HEADING_24: 'Total Permanent Employees',
  P3_HEADING_25: 'Total Permanent Workers',
  P3_HEADING_26: 'Employees',
  P3_HEADING_27: 'Workers',
  P3_HEADING_28: 'Total',
  P3_HEADING_29:
    'a. Whether an occupational health and safety management system has been implemented by the entity? (Yes/ No). If yes, the coverage such system?',
  P3_HEADING_30:
    'b. What are the processes used to identify work-related hazards and assess risks on a routine and non-routine basis by the entity?',
  P3_HEADING_31:
    'c. Whether you have processes for workers to report the work related hazards and to remove themselves from such risks.',
  P3_HEADING_32:
    'd. Do the employees/ worker of the entity have access to non-occupational medical  and healthcare services?',
  P3_HEADING_33: 'Total',
  P3_HEADING_34:
    'a. Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked) - ',
  P3_HEADING_36: 'No. of fatalities - ',
  P3_HEADING_37:
    'High consequence work-related injury or ill-health (excluding fatalities) - ',
  P3_HEADING_38: 'Safety Incident / Number',
  P3_HEADING_39: 'Working Conditions - ',
  P3_HEADING_40: 'Health & Safety - ',
  P3_HEADING_41:
    '% of your plants and offices that were assessed (by entity or statutory authorities or third parties)',
  P3_HEADING_42: 'Total no. of affected employees/ workers',
  P3_HEADING_44:
    '% of value chain partners (by value of business done with such partners) that were assessed',
  P3_HEADING_46: 'b. Details of measures for the well-being of workers:',
  P3_HEADING_48: `2. Details of retirement benefits, for ${FY.current} and ${FY.previous}.`,
  P3_HEADING_49:
    '3. Are the premises / offices of the entity accessible to differently abled employees and workers, as per the requirements of the Rights of Persons with Disabilities Act, 2016? If not, whether any steps are being taken by the entity in this regard.',
  P3_HEADING_50:
    '4. Does the entity have an equal opportunity policy as per the Rights of Persons with Disabilities Act, 2016? If so, provide a web-link to the policy.',
  P3_HEADING_51:
    '5. Return to work and Retention rates of permanent employees and workers that took parental leave.',
  P3_HEADING_52:
    '6. Is there a mechanism available to receive and redress grievances for the following categories of employees and worker? If yes, give details of the mechanism in brief.',
  P3_HEADING_53:
    '7. Membership of employees and worker in association(s) or Unions recognised by the listed entity:',
  P3_HEADING_54: '8. Details of training given to employees and workers',
  P3_HEADING_55:
    '9. Details of performance and career development reviews of employees and worker:',
  P3_HEADING_56: '10. Health and safety management system:',
  P3_HEADING_57:
    'a. Whether an occupational health and safety management system has been implemented by the entity? (Yes/ No). If yes, the coverage such system?',
  P3_HEADING_58:
    'b. What are the processes used to identify work-related hazards and assess risks on a routine and non-routine basis by the entity?',
  P3_HEADING_59:
    'c. Whether you have processes for workers to report the work related hazards and to remove themselves from such risks.',
  P3_HEADING_60:
    'd. Do the employees/ worker of the entity have access to non-occupational medical and healthcare services?',
  P3_HEADING_61:
    '11. Details of safety related incidents, in the following format:',
  P3_HEADING_62:
    '12. Describe the measures taken by the entity to ensure a safe and healthy work place.',
  P3_HEADING_63:
    '13. Number of Complaints on the following made by employees and workers:',
  P3_HEADING_64: '14. Assessments for the year:',
  P3_HEADING_65:
    '15. Provide details of any corrective action taken or underway to address safety-related incidents (if any) and on significant risks / concerns arising from assessments of health & safety practices and working conditions.',
  P3_HEADING_66:
    '1. Does the entity extend any life insurance or any compensatory package in the event of death of,',
  P3_HEADING_67:
    '2. Provide the measures undertaken by the entity to ensure that statutory dues have been deducted and deposited by the value chain partners.',
  P3_HEADING_68:
    '3. Provide the number of employees / workers having suffered high consequence work related injury / ill-health / fatalities (as reported in Q11 of Essential Indicators above), who have been are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment:',
  P3_HEADING_69: 'Total no. of Affected Employees',
  P3_HEADING_70:
    'No. of Employees that are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment',
  P3_HEADING_71: 'Total no. of Affected Workers',
  P3_HEADING_72:
    'No. of Workers that are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment',
  P3_HEADING_73:
    '4. Does the entity provide transition assistance programs to facilitate continued employability and the management of career endings resulting from retirement or termination of employment?',
  P3_HEADING_74: '5. Details on assessment of value chain partners:',
  P3_HEADING_75:
    '6. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from assessments of health and safety practices and working conditions of value chain partners.',

  P3_QUESTION_1: 'Permanent Male Employees',
  P3_QUESTION_2: 'Permanent Female Employees',
  P3_QUESTION_3: 'No. of Male Health Insurance',
  P3_QUESTION_4: 'No. of Female Health Insurance',
  P3_QUESTION_5: 'No. of Male Accident Insurance',
  P3_QUESTION_6: 'No. of Female Accident Insurance',
  P3_QUESTION_7: 'No. of Male Paternity Benefits',
  P3_QUESTION_8: 'No. of Female Maternity Benefits',
  P3_QUESTION_9: 'No. of Male Day Care Facilities',
  P3_QUESTION_10: 'No. of Female Day Care Facilities',
  P3_QUESTION_11: '% Male having Health Insurance',
  P3_QUESTION_12: '% Female having Health Insurance',
  P3_QUESTION_13: '% Male having Accident Insurance',
  P3_QUESTION_14: '% Female having Accident Insurance',
  P3_QUESTION_15: '% Male having Paternity Benefits',
  P3_QUESTION_16: '% Female having Maternity Benefits',
  P3_QUESTION_17: '% Male having Day Care Facilities',
  P3_QUESTION_18: '% Female having Day Care Facilities',
  P3_QUESTION_19: 'Other than Permanent Male Employees',
  P3_QUESTION_20: 'Other than Permanent Female Employees',
  P3_QUESTION_21: 'Permanent Male Workers',
  P3_QUESTION_22: 'Permanent Female Workers',
  P3_QUESTION_23: 'Other than Permanent Male Workers',
  P3_QUESTION_24: 'Other than Permanent Female Workers',
  P3_QUESTION_25: `In ( ${FY.current} )`,
  P3_QUESTION_26: `In ( ${FY.previous} )`,
  P3_QUESTION_27: 'No. of employees covered',
  P3_QUESTION_28: 'No. of workers covered',
  P3_QUESTION_29: 'Deducted and deposited with the authority',
  P3_QUESTION_33: 'Employees',
  P3_QUESTION_34:
    'Male Employees that did return to work after parental leave in reporting period',
  P3_QUESTION_35:
    'Female Employees that did return to work after parental leave in reporting period',
  P3_QUESTION_36:
    'Male Employees due to return to work after taking parental leave in reporting period',
  P3_QUESTION_37:
    'Female Employees due to return to work after taking parental leave in reporting period',
  P3_QUESTION_38: 'Total Employees Return to Work Rate',
  P3_QUESTION_39: 'Male Employees Return to Work Rate',
  P3_QUESTION_40: 'Female Employees Return to Work Rate',
  P3_QUESTION_41:
    'Male Employees retained 12 months after returning to work following a period of parental leave',
  P3_QUESTION_42:
    'Female Employees retained 12 months after returning to work following a period of parental leave',
  P3_QUESTION_128:
    'Male Employees returning from parental leave in prior reporting period',
  P3_QUESTION_129:
    'Female Employees returning from parental leave in prior reporting period',
  P3_QUESTION_130: 'Total Employees Retention rate',
  P3_QUESTION_131: 'Male Employees Retention rate',
  P3_QUESTION_132: 'Female Employees Retention rate',
  P3_QUESTION_133: 'Workers',
  P3_QUESTION_134:
    'Male Workers that did return to work after parental leave in reporting period',
  P3_QUESTION_135:
    'Female Workers that did return to work after parental leave in reporting period',
  P3_QUESTION_136:
    'Male Workers due to return to work after taking parental leave in reporting period',
  P3_QUESTION_137:
    'Female Workers due to return to work after taking parental leave in reporting period',
  P3_QUESTION_138: 'Total Workers Return to Work Rate',
  P3_QUESTION_139: 'Male Workers Return to Work Rate',
  P3_QUESTION_140: 'Female Workers Return to Work Rate',
  P3_QUESTION_141:
    'Male Workers retained 12 months after returning to work following a period of parental leave',
  P3_QUESTION_142:
    'Female Workers retained 12 months after returning to work following a period of parental leave',
  P3_QUESTION_143:
    'Male Workers returning from parental leave in prior reporting period',
  P3_QUESTION_144:
    'Female Workers returning from parental leave in prior reporting period',
  P3_QUESTION_145: 'Total Workers Retention rate',
  P3_QUESTION_146: 'Male Workers Retention rate',
  P3_QUESTION_147: 'Female Workers Retention rate',

  P3_QUESTION_44: 'Permanent Employees',
  P3_QUESTION_45: 'Other than Permanent Employees',
  P3_QUESTION_46: 'Permanent Workers',
  P3_QUESTION_47: 'Other than Permanent Workers',

  P3_QUESTION_49:
    'No. of Male Employees, who are part of association(s) or Union',
  P3_QUESTION_50:
    'No. of Female Employees, who are part of association(s) or Union',
  P3_QUESTION_51: `Total Male in ${FY.current}`,
  P3_QUESTION_52: `Total Female in ${FY.current}`,
  P3_QUESTION_53: `% Male In ${FY.current}`,
  P3_QUESTION_54: `% Male In ${FY.previous}`,
  P3_QUESTION_55: `% Female In ${FY.current}`,
  P3_QUESTION_56: `% Female In ${FY.previous}`,
  P3_QUESTION_57:
    'No. of Male Workers, who are part of association(s) or Union',
  P3_QUESTION_58:
    'No. of Female Workers, who are part of association(s) or Union',

  P3_QUESTION_60: 'Male Employees On Health and safety measures',
  P3_QUESTION_61: 'Female Employees On Health and safety measures',
  P3_QUESTION_62: 'Male Employees On Skill upgradation',
  P3_QUESTION_63: 'Female Employees On Skill upgradation',
  P3_QUESTION_64: '% Total  On Health and safety measures',
  P3_QUESTION_65: '% Total  On Skill upgradation',
  P3_QUESTION_66: '% Male  On Health and safety measures',
  P3_QUESTION_67: '% Female  On Health and safety measures',
  P3_QUESTION_68: '% Male  On Skill upgradation',
  P3_QUESTION_69: '% Female  On Skill upgradation',
  P3_QUESTION_70: 'Male Workers On Health and safety measures',
  P3_QUESTION_71: 'Female Workers On Health and safety measures',
  P3_QUESTION_72: 'Male Workers On Skill upgradation',
  P3_QUESTION_73: 'Female Workers On Skill upgradation',
  P3_QUESTION_74: '% Total  On Health and safety measures',
  P3_QUESTION_75: '% Total  On Skill upgradation',
  P3_QUESTION_76: '% Male  On Health and safety measures',
  P3_QUESTION_77: '% Female  On Health and safety measures',
  P3_QUESTION_78: '% Male  On Skill upgradation',
  P3_QUESTION_79: '% Female  On Skill upgradation',

  P3_QUESTION_81: 'No of Male Employees Reviews',
  P3_QUESTION_82: 'No of Female Employees Reviews',
  P3_QUESTION_83: `% of Total Employees in ${FY.current}`,
  P3_QUESTION_84: `% of Total Employees in ${FY.previous}`,
  P3_QUESTION_85: `% of Male Employees in ${FY.current}`,
  P3_QUESTION_86: `% of Male Employees in ${FY.previous}`,
  P3_QUESTION_87: `% of Female Employees in ${FY.current}`,
  P3_QUESTION_88: `% of Female Employees in ${FY.previous}`,
  P3_QUESTION_89: 'No of Male Workers Reviews',
  P3_QUESTION_90: 'No of Female Workers Reviews',
  P3_QUESTION_91: `% of Total Workers in ${FY.current}`,
  P3_QUESTION_92: `% of Total Workers in ${FY.previous}`,
  P3_QUESTION_93: `% of Male Workers in ${FY.current}`,
  P3_QUESTION_94: `% of Male Workers in ${FY.previous}`,
  P3_QUESTION_95: `% of Female Workers in ${FY.current}`,
  P3_QUESTION_96: `% of Female Workers in ${FY.previous}`,

  P3_QUESTION_99: '',
  P3_QUESTION_101: '',
  P3_QUESTION_103: '',
  P3_QUESTION_105: '',
  P3_QUESTION_107: 'Safety Incident / Number',
  P3_QUESTION_108:
    'a. Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked) -',
  P3_QUESTION_109: 'Total number of working days lost',
  P3_QUESTION_110: 'Total hours worked',
  P3_QUESTION_111: 'b. Total recordable work-related injuries -',
  P3_QUESTION_112: 'c. No. of fatalities -',
  P3_QUESTION_113:
    'd. High consequence work-related injury or ill-health (excluding fatalities) -',
  P3_QUESTION_116: 'a. Working Conditions -',
  P3_QUESTION_117: 'Filed during the year',
  P3_QUESTION_118: 'Pending resolution at the end of year',
  P3_QUESTION_119: 'Remarks',
  P3_QUESTION_120: 'b. Health & Safety -',

  P3_QUESTION_122:
    '% of your plants and offices that were assessed (by entity or statutory authorities or third parties)',
  P3_QUESTION_123: 'a. Health and safety practices',
  P3_QUESTION_124: 'b. Working Conditions',
  P3_QUESTION_126: '',
  P3_QUESTION_127: '',
  P3_QUESTION_148: `% of Employees Covered in (${FY.current})`,
  P3_QUESTION_149: `% of Workers Covered in (${FY.current})`,
  P3_QUESTION_150: `% of Employees Covered in (${FY.previous})`,
  P3_QUESTION_151: `% of Workers Covered in (${FY.previous})`,

  P3_QUESTION_152: 'Total Employees having Health Insurance',
  P3_QUESTION_153: '% Total Employees having Health Insurance',
  P3_QUESTION_154: 'Total Employees having Accident Insurance',
  P3_QUESTION_155: '% Total Employees having Accident Insurance',
  P3_QUESTION_156: 'Total Employees having Paternity Benefits',
  P3_QUESTION_157: '% Total Employees having Paternity Benefits',
  P3_QUESTION_158: 'Total Employees having Maternity Benefits',
  P3_QUESTION_159: '% Total Employees having Maternity Benefits',
  P3_QUESTION_160: 'Total Employees having Day Care Facilities',
  P3_QUESTION_161: '% Total Employees having Day Care Facilities',
  P3_QUESTION_162: 'Total Workers having Health Insurance',
  P3_QUESTION_163: '% Total Workers having Health Insurance',
  P3_QUESTION_164: 'Total Workers having Accident Insurance',
  P3_QUESTION_165: '% Total Workers having Accident Insurance',
  P3_QUESTION_166: 'Total Workers having Paternity Benefits',
  P3_QUESTION_167: '% Total Workers having Paternity Benefits',
  P3_QUESTION_168: 'Total Workers having Maternity Benefits',
  P3_QUESTION_169: '% Total Workers having Maternity Benefits',
  P3_QUESTION_170: 'Total Workers having Day Care Facilities',
  P3_QUESTION_171: '% Total Workers having Day Care Facilities',

  P3_QUESTION_172: `Total Male in ${FY.previous}`,
  P3_QUESTION_173: `Total Female in ${FY.previous}`,
  P3_QUESTION_174: `Lost Time Injury Frequency Rate (LTIFR) Employees In (${FY.current})`,
  P3_QUESTION_175: `Lost Time Injury Frequency Rate (LTIFR) Employees In (${FY.previous})`,
  P3_QUESTION_176: `Lost Time Injury Frequency Rate (LTIFR) Workers In (${FY.current})`,
  P3_QUESTION_177: `Lost Time Injury Frequency Rate (LTIFR) Workers In (${FY.previous})`,
  P3_QUESTION_178: `% Total In (${FY.current})`,
  P3_QUESTION_179: `% Total In (${FY.previous})`,
  P3_QUESTION_180: 'Total Employees, who are part of association(s) or Union',
  P3_QUESTION_181: 'Total Workers, who are part of association(s) or Union',
  P3_QUESTION_182: 'Total On Health and safety measures',
  P3_QUESTION_183: 'Total On Skill upgradation',
  P3_QUESTION_184: `Total Employees In (${FY.current})`,
  P3_QUESTION_185: `Total Employees In (${FY.previous})`,
  P3_QUESTION_186: `Total Workers In (${FY.current})`,
  P3_QUESTION_187: `Total Workers In (${FY.previous})`,
  P3_QUESTION_188: `Total Employees Reviews In (${FY.current})`,
  P3_QUESTION_189: `Total Employees Reviews In (${FY.previous})`,
  P3_QUESTION_190: `Total Workers Reviews In (${FY.current})`,
  P3_QUESTION_191: `Total Workers Reviews In (${FY.previous})`
};

// principle4----------------------------------
export const Principle4Key = {
  P4_QUESTION_1: 'p4Question1',
  P4_QUESTION_2: 'p4Question2',
  P4_QUESTION_3: 'p4Question3',
  P4_QUESTION_4: 'p4Question4',
  P4_QUESTION_5: 'p4Question5',
  P4_QUESTION_6: 'p4Question6',
  P4_QUESTION_7: 'p4Question7',
  P4_QUESTION_8: 'p4Question8',
  P4_QUESTION_9: 'p4Question9',

  P4_QUESTION_10: 'p4Question10',
  P4_QUESTION_11: 'p4Question11',
  P4_QUESTION_12: 'p4Question12',
  P4_QUESTION_13: 'p4Question13',
  P4_QUESTION_14: 'p4Question14',
  P4_QUESTION_15: 'p4Question15',
  P4_QUESTION_16: 'p4Question16',
  P4_QUESTION_17: 'p4Question17',
  P4_QUESTION_18: 'p4Question18',
  P4_QUESTION_19: 'p4Question19',
  P4_QUESTION_20: 'p4Question20',

  P4_QUESTION_21: 'p4Question21',
  P4_QUESTION_22: 'p4Question22',
  P4_QUESTION_23: 'p4Question23',
  P4_QUESTION_24: 'p4Question24',
  P4_QUESTION_25: 'p4Question25',
  P4_QUESTION_26: 'p4Question26',
  P4_QUESTION_27: 'p4Question27',
  P4_QUESTION_28: 'p4Question28',
  P4_QUESTION_29: 'p4Question29',
  P4_QUESTION_30: 'p4Question30',
  P4_QUESTION_31: 'p4Question31'
};

export const Principle4Label = {
  P4_HEADING_1:
    'Businesses should respect the interests of and be  responsive to all its stakeholders',
  P4_HEADINGLABEL_1: 'Essential Indicators',
  P4_HEADINGLABEL_2: 'Leadership Indicators',

  P4_QUESTION_1:
    '1. Describe the processes for identifying key stakeholder groups of the entity.',
  P4_QUESTION_2:
    '2. List stakeholder groups identified as key for your entity and the frequency of engagement with each stakeholder group.',
  P4_QUESTION_3:
    '1. Provide the processes for consultation between stakeholders and the Board on economic, environmental, and social topics or if consultation is delegated, how is feedback from such consultations provided to the Board.',
  P4_QUESTION_4:
    '2. Whether stakeholder consultation is used to support the identification and management of environmental, and social topics (Yes / No). If so, provide details of instances as to how the inputs received from stakeholders on these topics were incorporated into policies and activities of the entity.',
  P4_QUESTION_5:
    '3. Provide details of instances of engagement with, and actions taken to, address the concerns of vulnerable/ marginalized stakeholder groups.',

  P4_HEADING_4: 'Stakeholder Group',
  P4_HEADING_5: 'Whether identified as Vulnerable & Marginalized Group',
  P4_HEADING_6:
    'Channels of communication (Email, SMS, Newspaper, Pamphlets, Advertisement, Community Meetings, Notice Board, Website), Other',
  P4_HEADING_7:
    'Frequency of engagement (Annually/ Half yearly/ Quarterly / others - please specify)',
  P4_HEADING_8:
    'Purpose and scope of engagement including key topics and concerns raised during such engagement',
  P4_HEADING_9: '',
  P4_HEADING_10: '',

  P4_LABEL_1: '',
  P4_LABEL_2: '',
  P4_LABEL_3: '',
  P4_LABEL_4: '',
  P4_LABEL_5: '',
  P4_LABEL_6: '',
  P4_LABEL_7: '',
  P4_LABEL_8: '',
  P4_LABEL_9: ''
};

// principle5----------------------------------
export const Principle5Key = {
  P5_QUESTION_1: 'p5Question1',
  P5_QUESTION_2: 'p5Question2',
  P5_QUESTION_3: 'p5Question3',
  P5_QUESTION_4: 'p5Question4',
  P5_QUESTION_5: 'p5Question5',
  P5_QUESTION_6: 'p5Question6',
  P5_QUESTION_7: 'p5Question7',
  P5_QUESTION_8: 'p5Question8',
  P5_QUESTION_9: 'p5Question9',

  P5_QUESTION_10: 'p5Question10',
  P5_QUESTION_11: 'p5Question11',
  P5_QUESTION_12: 'p5Question12',
  P5_QUESTION_13: 'p5Question13',
  P5_QUESTION_14: 'p5Question14',
  P5_QUESTION_15: 'p5Question15',
  P5_QUESTION_16: 'p5Question16',
  P5_QUESTION_17: 'p5Question17',
  P5_QUESTION_18: 'p5Question18',
  P5_QUESTION_19: 'p5Question19',
  P5_QUESTION_20: 'p5Question20',

  P5_QUESTION_21: 'p5Question21',
  P5_QUESTION_22: 'p5Question22',
  P5_QUESTION_23: 'p5Question23',
  P5_QUESTION_24: 'p5Question24',
  P5_QUESTION_25: 'p5Question25',
  P5_QUESTION_26: 'p5Question26',
  P5_QUESTION_27: 'p5Question27',
  P5_QUESTION_28: 'p5Question28',
  P5_QUESTION_29: 'p5Question29',
  P5_QUESTION_30: 'p5Question30',

  P5_QUESTION_31: 'p5Question31',
  P5_QUESTION_32: 'p5Question32',
  P5_QUESTION_33: 'p5Question33',
  P5_QUESTION_34: 'p5Question34',
  P5_QUESTION_35: 'p5Question35',
  P5_QUESTION_36: 'p5Question36',
  P5_QUESTION_37: 'p5Question37',
  P5_QUESTION_38: 'p5Question38',
  P5_QUESTION_39: 'p5Question39',
  P5_QUESTION_40: 'p5Question40',

  P5_QUESTION_41: 'p5Question41',
  P5_QUESTION_42: 'p5Question42',
  P5_QUESTION_43: 'p5Question43',
  P5_QUESTION_44: 'p5Question44',
  P5_QUESTION_45: 'p5Question45',
  P5_QUESTION_46: 'p5Question46',
  P5_QUESTION_47: 'p5Question47',
  P5_QUESTION_48: 'p5Question48',
  P5_QUESTION_49: 'p5Question49',
  P5_QUESTION_50: 'p5Question50',

  P5_QUESTION_51: 'p5Question51',
  P5_QUESTION_52: 'p5Question52',
  P5_QUESTION_53: 'p5Question53',
  P5_QUESTION_54: 'p5Question54',
  P5_QUESTION_55: 'p5Question55',
  P5_QUESTION_56: 'p5Question56',
  P5_QUESTION_57: 'p5Question57',
  P5_QUESTION_58: 'p5Question58',
  P5_QUESTION_59: 'p5Question59',
  P5_QUESTION_60: 'p5Question60',

  P5_QUESTION_61: 'p5Question61',
  P5_QUESTION_62: 'p5Question62',
  P5_QUESTION_63: 'p5Question63',
  P5_QUESTION_64: 'p5Question64',
  P5_QUESTION_65: 'p5Question65',
  P5_QUESTION_66: 'p5Question66',
  P5_QUESTION_67: 'p5Question67',
  P5_QUESTION_68: 'p5Question68',
  P5_QUESTION_69: 'p5Question69',
  P5_QUESTION_70: 'p5Question70',

  P5_QUESTION_71: 'p5Question71',
  P5_QUESTION_72: 'p5Question72',
  P5_QUESTION_73: 'p5Question73',
  P5_QUESTION_74: 'p5Question74',
  P5_QUESTION_75: 'p5Question75',
  P5_QUESTION_76: 'p5Question76',
  P5_QUESTION_77: 'p5Question77',
  P5_QUESTION_78: 'p5Question78',
  P5_QUESTION_79: 'p5Question79',
  P5_QUESTION_80: 'p5Question80',

  P5_QUESTION_81: 'p5Question81',
  P5_QUESTION_82: 'p5Question82',
  P5_QUESTION_83: 'p5Question83',
  P5_QUESTION_84: 'p5Question84',
  P5_QUESTION_85: 'p5Question85',
  P5_QUESTION_86: 'p5Question86',
  P5_QUESTION_87: 'p5Question87',
  P5_QUESTION_88: 'p5Question88',
  P5_QUESTION_89: 'p5Question89',
  P5_QUESTION_90: 'p5Question90',

  P5_QUESTION_91: 'p5Question91',
  P5_QUESTION_92: 'p5Question92',
  P5_QUESTION_93: 'p5Question93',
  P5_QUESTION_94: 'p5Question94',
  P5_QUESTION_95: 'p5Question95',
  P5_QUESTION_96: 'p5Question96',
  P5_QUESTION_97: 'p5Question97',
  P5_QUESTION_98: 'p5Question98',
  P5_QUESTION_99: 'p5Question99',
  P5_QUESTION_100: 'p5Question100',

  P5_QUESTION_101: 'p5Question101',
  P5_QUESTION_102: 'p5Question102',
  P5_QUESTION_103: 'p5Question103',
  P5_QUESTION_104: 'p5Question104',
  P5_QUESTION_105: 'p5Question105',
  P5_QUESTION_106: 'p5Question106',
  P5_QUESTION_107: 'p5Question107',
  P5_QUESTION_108: 'p5Question108',
  P5_QUESTION_109: 'p5Question109',
  P5_QUESTION_110: 'p5Question110',

  P5_QUESTION_111: 'p5Question111',
  P5_QUESTION_112: 'p5Question112',
  P5_QUESTION_113: 'p5Question113',
  P5_QUESTION_114: 'p5Question114',
  P5_QUESTION_115: 'p5Question115',
  P5_QUESTION_116: 'p5Question116',
  P5_QUESTION_117: 'p5Question117',
  P5_QUESTION_118: 'p5Question118',
  P5_QUESTION_119: 'p5Question119',
  P5_QUESTION_120: 'p5Question120',

  P5_QUESTION_121: 'p5Question121',
  P5_QUESTION_122: 'p5Question122',
  P5_QUESTION_123: 'p5Question123',
  P5_QUESTION_124: 'p5Question124',
  P5_QUESTION_125: 'p5Question125',
  P5_QUESTION_126: 'p5Question126',
  P5_QUESTION_127: 'p5Question127',
  P5_QUESTION_128: 'p5Question128',
  P5_QUESTION_129: 'p5Question129',
  P5_QUESTION_130: 'p5Question130',

  P5_QUESTION_131: 'p5Question131',
  P5_QUESTION_132: 'p5Question132',
  P5_QUESTION_133: 'p5Question133',
  P5_QUESTION_134: 'p5Question134',
  P5_QUESTION_135: 'p5Question135',
  P5_QUESTION_136: 'p5Question136',
  P5_QUESTION_137: 'p5Question137',
  P5_QUESTION_138: 'p5Question138',
  P5_QUESTION_139: 'p5Question139',
  P5_QUESTION_140: 'p5Question140',

  P5_QUESTION_141: 'p5Question141',
  P5_QUESTION_142: 'p5Question142',
  P5_QUESTION_143: 'p5Question143',
  P5_QUESTION_144: 'p5Question144',
  P5_QUESTION_145: 'p5Question145',
  P5_QUESTION_146: 'p5Question146',
  P5_QUESTION_147: 'p5Question147',
  P5_QUESTION_148: 'p5Question148',
  P5_QUESTION_149: 'p5Question149',
  P5_QUESTION_150: 'p5Question150',

  P5_QUESTION_151: 'p5Question151',
  P5_QUESTION_152: 'p5Question152',
  P5_QUESTION_153: 'p5Question153',
  P5_QUESTION_154: 'p5Question154',
  P5_QUESTION_155: 'p5Question155',
  P5_QUESTION_156: 'p5Question156',
  P5_QUESTION_157: 'p5Question157',
  P5_QUESTION_158: 'p5Question158',
  P5_QUESTION_159: 'p5Question159',
  P5_QUESTION_160: 'p5Question160',

  P5_QUESTION_161: 'p5Question161',
  P5_QUESTION_162: 'p5Question162',
  P5_QUESTION_163: 'p5Question163',
  P5_QUESTION_164: 'p5Question164',
  P5_QUESTION_165: 'p5Question165',
  P5_QUESTION_166: 'p5Question166',
  P5_QUESTION_167: 'p5Question167',
  P5_QUESTION_168: 'p5Question168',
  P5_QUESTION_169: 'p5Question169',
  P5_QUESTION_170: 'p5Question170',

  P5_QUESTION_171: 'p5Question171',
  P5_QUESTION_172: 'p5Question172',
  P5_QUESTION_173: 'p5Question173',
  P5_QUESTION_174: 'p5Question174',
  P5_QUESTION_175: 'p5Question175',
  P5_QUESTION_176: 'p5Question176',
  P5_QUESTION_177: 'p5Question177',
  P5_QUESTION_178: 'p5Question178',
  P5_QUESTION_179: 'p5Question179',
  P5_QUESTION_180: 'p5Question180',

  P5_QUESTION_181: 'p5Question181',
  P5_QUESTION_182: 'p5Question182',
  P5_QUESTION_183: 'p5Question183',
  P5_QUESTION_184: 'p5Question184',
  P5_QUESTION_185: 'p5Question185',
  P5_QUESTION_186: 'p5Question186',
  P5_QUESTION_187: 'p5Question187',
  P5_QUESTION_188: 'p5Question188',
  P5_QUESTION_189: 'p5Question189',
  P5_QUESTION_190: 'p5Question190',

  P5_QUESTION_191: 'p5Question191',
  P5_QUESTION_192: 'p5Question192',
  P5_QUESTION_193: 'p5Question193',
  P5_QUESTION_194: 'p5Question194',
  P5_QUESTION_195: 'p5Question195',
  P5_QUESTION_196: 'p5Question196',
  P5_QUESTION_197: 'p5Question197',
  P5_QUESTION_198: 'p5Question198',
  P5_QUESTION_199: 'p5Question199',
  P5_QUESTION_200: 'p5Question200',

  P5_QUESTION_201: 'p5Question201',
  P5_QUESTION_202: 'p5Question202',
  P5_QUESTION_203: 'p5Question203',
  P5_QUESTION_204: 'p5Question204',
  P5_QUESTION_205: 'p5Question205',
  P5_QUESTION_206: 'p5Question206',
  P5_QUESTION_207: 'p5Question207',
  P5_QUESTION_208: 'p5Question208',
  P5_QUESTION_209: 'p5Question209',
  P5_QUESTION_210: 'p5Question210',

  P5_QUESTION_211: 'p5Question211',
  P5_QUESTION_212: 'p5Question212',
  P5_QUESTION_213: 'p5Question213',
  P5_QUESTION_214: 'p5Question214',
  P5_QUESTION_215: 'p5Question215',
  P5_QUESTION_216: 'p5Question216',
  P5_QUESTION_217: 'p5Question217',
  P5_QUESTION_218: 'p5Question218',
  P5_QUESTION_219: 'p5Question219',
  P5_QUESTION_220: 'p5Question220',

  P5_QUESTION_221: 'p5Question221',
  P5_QUESTION_222: 'p5Question222',
  P5_QUESTION_223: 'p5Question223',
  P5_QUESTION_224: 'p5Question224',
  P5_QUESTION_225: 'p5Question225',
  P5_QUESTION_226: 'p5Question226',
  P5_QUESTION_227: 'p5Question227',
  P5_QUESTION_228: 'p5Question228',
  P5_QUESTION_229: 'p5Question229',
  P5_QUESTION_230: 'p5Question230',

  P5_QUESTION_231: 'p5Question231',
  P5_QUESTION_232: 'p5Question232',
  P5_QUESTION_233: 'p5Question233',
  P5_QUESTION_234: 'p5Question234',
  P5_QUESTION_235: 'p5Question235',
  P5_QUESTION_236: 'p5Question236',
  P5_QUESTION_237: 'p5Question237',
  P5_QUESTION_238: 'p5Question238',
  P5_QUESTION_239: 'p5Question239',
  P5_QUESTION_240: 'p5Question240',

  P5_QUESTION_241: 'p5Question241',
  P5_QUESTION_242: 'p5Question242',
  P5_QUESTION_243: 'p5Question243',
  P5_QUESTION_244: 'p5Question244',
  P5_QUESTION_245: 'p5Question245',
  P5_QUESTION_246: 'p5Question246',
  P5_QUESTION_247: 'p5Question247',
  P5_QUESTION_248: 'p5Question248',
  P5_QUESTION_249: 'p5Question249',
  P5_QUESTION_250: 'p5Question250',
  P5_QUESTION_251: 'p5Question251',
  P5_QUESTION_252: 'p5Question252',
  P5_QUESTION_253: 'p5Question253',
  P5_QUESTION_254: 'p5Question254',
  P5_QUESTION_255: 'p5Question255',
  P5_QUESTION_256: 'p5Question256',
  P5_QUESTION_257: 'p5Question257',
  P5_QUESTION_258: 'p5Question258',
  P5_QUESTION_259: 'p5Question259',
  P5_QUESTION_260: 'p5Question260',
  P5_QUESTION_261: 'p5Question261',

  P5_QUESTION_262: 'p5Question262',
  P5_QUESTION_263: 'p5Question263',
  P5_QUESTION_264: 'p5Question264',
  P5_QUESTION_265: 'p5Question265',
  P5_QUESTION_266: 'p5Question266',
  P5_QUESTION_267: 'p5Question267',
  P5_QUESTION_268: 'p5Question268',
  P5_QUESTION_269: 'p5Question269',
  P5_QUESTION_270: 'p5Question270',
  P5_QUESTION_271: 'p5Question271',
  P5_QUESTION_272: 'p5Question272',
  P5_QUESTION_273: 'p5Question273',
  P5_QUESTION_274: 'p5Question274',
  P5_QUESTION_275: 'p5Question275',
  P5_QUESTION_276: 'p5Question276',
  P5_QUESTION_277: 'p5Question277',
  P5_QUESTION_278: 'p5Question278',
  P5_QUESTION_279: 'p5Question279',
  P5_QUESTION_280: 'p5Question280',
  P5_QUESTION_281: 'p5Question281',
  P5_QUESTION_282: 'p5Question282',

  P5_QUESTION_283: 'p5Question283',
  P5_QUESTION_284: 'p5Question284',
  P5_QUESTION_285: 'p5Question285',
  P5_QUESTION_286: 'p5Question286',
  P5_QUESTION_287: 'p5Question287',
  P5_QUESTION_288: 'p5Question288',
  P5_QUESTION_289: 'p5Question289'
};

export const Principle5Label = {
  P5_HEADING_1: 'Businesses should respect and promote human rights',
  P5_HEADINGLABEL_1: 'Essential Indicators',
  P5_HEADINGLABEL_2: 'Leadership Indicators',

  P5_QUESTION_1:
    '1. Employees and workers who have been provided training on human rights issues and policy(ies) of the entity, in the following format:',
  P5_QUESTION_2:
    '2. Details of minimum wages paid to employees and workers, in the following format:',
  P5_QUESTION_3: '3. Details of remuneration/salary/wages',
  P5_QUESTION_4:
    '4. Do you have a focal point (Individual/ Committee) responsible for addressing human rights impacts or issues caused or contributed to by the business?',
  P5_QUESTION_5:
    '5. Describe the internal mechanisms in place to redress grievances related to human rights issues.',
  P5_QUESTION_6:
    '6. Number of Complaints on the following made by employees and workers:',
  P5_QUESTION_7:
    '7. Complaints filed under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013, in the following format:',
  P5_QUESTION_8:
    '8. Mechanisms to prevent adverse consequences to the complainant in discrimination and harassment cases.',
  P5_QUESTION_9:
    '9. Do human rights requirements form part of your business agreements and contracts?',
  P5_QUESTION_10: '10. Assessments for the year:',
  P5_QUESTION_11:
    '11. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 10 above.',

  P5_QUESTION_12:
    '1. Details of a business process being modified / introduced as a result of addressing human rights grievances/complaints.',
  P5_QUESTION_13:
    '2. Details of the scope and coverage of any Human rights due-diligence conducted.',
  P5_QUESTION_14:
    '3. Is the premise/office of the entity accessible to differently abled visitors, as per the requirements of the Rights of Persons with Disabilities Act, 2016?',
  P5_QUESTION_15: '4. Details on assessment of value chain partners:',
  P5_QUESTION_16:
    '5. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 4 above.',

  P5_HEADING_4: `In ( ${FY.current} )`,
  P5_HEADING_5: `In ( ${FY.previous} )`,
  P5_HEADING_6: 'Permanent employees',
  P5_HEADING_7: 'Other than Permanent employees',
  P5_HEADING_8: 'Male Category',
  P5_HEADING_9: 'Female Category',
  P5_HEADING_10: 'Total',
  P5_HEADING_11: 'Permanent workers',
  P5_HEADING_12: 'Other than Permanent workers',
  P5_HEADING_13: 'a. Employees',
  P5_HEADING_14: 'b. Workers',
  P5_HEADING_15: 'a. Median remuneration / wages',
  P5_HEADING_16:
    'b. Gross wages paid to females as % of total wages paid by the entity, in the following format:',
  P5_HEADING_17: 'i. Board of Directors (BoD) -',
  P5_HEADING_18: 'ii. Key Managerial Personnel - ',
  P5_HEADING_19: 'iii. Employees other than BoD and KMP - ',
  P5_HEADING_20: 'iv. Workers - ',
  P5_HEADING_21: 'Gross wages paid to females as % of total wages',
  P5_HEADING_22: 'a. Sexual Harassment',
  P5_HEADING_23: 'b. Discrimination at workplace',
  P5_HEADING_24: 'c. Child Labour',
  P5_HEADING_25: 'd. Forced Labour/Involuntary Labour',
  P5_HEADING_26: 'e. Wages',
  P5_HEADING_27: 'f. Other human rights related issues',
  P5_HEADING_35: 'a. Child Labour',
  P5_HEADING_36: 'b. Forced Labour/Involuntary Labour',
  P5_HEADING_37: 'c. Sexual Harassment',
  P5_HEADING_38: 'd. Discrimination at workplace',
  P5_HEADING_39: 'e. Wages',
  P5_HEADING_40: 'f. Others-please specify',
  P5_HEADING_28:
    'a. Total Complaints reported under Sexual Harassment on of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (POSH) -',
  P5_HEADING_29:
    'b. Complaints on POSH as a % of female employees / workers  - ',
  P5_HEADING_30: 'c. Complaints on POSH upheld - ',
  P5_HEADING_32: 'Others-please specify',
  P5_HEADING_33:
    '% of your plants and offices that were assessed (by entity or statutory authorities or third parties)',
  P5_HEADING_34:
    '% of value chain partners (by value of business done with such partners) that were assessed',

  P5_LABEL_1: 'Permanent Employees',
  P5_LABEL_2: 'Other than Permanent employees',
  P5_LABEL_3: 'Permanent Employees Covered',
  P5_LABEL_4: 'Other than Permanent Employees Covered',
  P5_LABEL_5: 'Total Employees Covered',
  P5_LABEL_6: 'Permanent Employees Covered',
  P5_LABEL_7: 'Other than Permanent Employees Covered',
  P5_LABEL_8: 'Permanent Workers',
  P5_LABEL_9: 'Other than Permanent Workers',
  P5_LABEL_10: 'Permanent Workers Covered',
  P5_LABEL_11: 'Other than Permanent Workers Covered',
  P5_LABEL_12: 'Total Workers Covered',
  P5_LABEL_13: 'Permanent Workers Covered',
  P5_LABEL_14: 'Other than Permanent Workers Covered',

  P5_LABEL_15: 'Total (C)',
  P5_LABEL_16: 'No. of  employees / workers covered (D)',
  P5_LABEL_17: '% (D / C)',
  P5_LABEL_18: 'Total (C)',
  P5_LABEL_19: 'No. of  employees / workers covered (D)',
  P5_LABEL_20: '% (D / C)',

  P5_LABEL_77: 'Employees',
  P5_LABEL_78: 'Workers',

  P5_LABEL_79: `In ( ${FY.current} )`,
  P5_LABEL_140: `In ( ${FY.previous} )`,

  P5_LABEL_101: 'Total Workers',
  P5_LABEL_102: 'Male having Equal to Minimum Wage',
  P5_LABEL_103: '% Male having Equal to Minimum Wage',
  P5_LABEL_104: 'Male having More than Minimum Wage',
  P5_LABEL_105: '% Female having Equal to Minimum Wage',
  P5_LABEL_106: 'Total',
  P5_LABEL_107: 'Female having Equal to Minimum Wage',
  P5_LABEL_108: '% Male having More than Minimum Wage',
  P5_LABEL_109: 'Female having More than Minimum Wage',
  P5_LABEL_110: '% Female having More than Minimum Wage',
  P5_LABEL_111: 'Permanent Male Employees',
  P5_LABEL_112: 'Permanent Female Employees',
  P5_LABEL_113: 'Total Employees having Equal to Minimum Wage',
  P5_LABEL_114: 'Total Employees having More than Minimum Wage',

  P5_LABEL_115: 'Permanent Male Workers',
  P5_LABEL_116: 'Permanent Female Workers',
  P5_LABEL_117: 'Total Workers having Equal to Minimum Wage',
  P5_LABEL_118: 'Total Workers having More than Minimum Wage',
  P5_LABEL_119: '',
  P5_LABEL_120: '',
  P5_LABEL_121: '',
  P5_LABEL_122: '',
  P5_LABEL_123: '',
  P5_LABEL_124: '',
  P5_LABEL_125: '',
  P5_LABEL_126: '',
  P5_LABEL_127: '',

  P5_LABEL_29: 'Total (A)',
  P5_LABEL_30: 'On Health and safety measures (B)',
  P5_LABEL_31: 'On Health and safety measures %  (B / A)',
  P5_LABEL_32: 'On Skill upgradation (C)',
  P5_LABEL_33: 'On Skill upgradation %  (C / A)',
  P5_LABEL_34: 'Total (D)',
  P5_LABEL_35: 'On Health and safety measures (E)',
  P5_LABEL_36: 'On Health and safety measures %  (E / D)',
  P5_LABEL_37: 'On Skill upgradation (F)',
  P5_LABEL_38: 'On Skill upgradation %  (F / D)',

  P5_LABEL_39: 'Number',
  P5_LABEL_40: 'Median remuneration/ salary/ wages of respective category(₹)',

  P5_LABEL_41: 'Filed during the year',
  P5_LABEL_42: 'Pending resolution at the end of year',
  P5_LABEL_43: 'Remarks',
  P5_LABEL_44: 'N/A',
  P5_LABEL_45: '% of Total Employees Covered',
  P5_LABEL_46: '% of Permanent Employees Covered',
  P5_LABEL_47: '% of Other than Permanent Employees Covered',
  P5_LABEL_48: '% of Total Workers Covered',
  P5_LABEL_49: '% of Permanent Workers Covered',
  P5_LABEL_50: '% of Other than Permanent Workers Covered',

  P5_LABEL_51: 'Permanent Employees having Equal to Minimum Wage',
  P5_LABEL_52: '% of Permanent Employees having Equal to Minimum Wage',
  P5_LABEL_53: 'Permanent Employees having More than Minimum Wage',
  P5_LABEL_54: '% of Permanent Employees having More than Minimum Wage',
  P5_LABEL_55: 'Total Permanent Employees',
  P5_LABEL_56: 'Total Other than Permanent Employees',
  P5_LABEL_57: 'Total Permanent Workers',
  P5_LABEL_58: 'Total Other than Permanent Workers',

  P5_LABEL_59: 'Permanent Workers having Equal to Minimum Wage',
  P5_LABEL_60: '% of Permanent Workers having Equal to Minimum Wage',
  P5_LABEL_61: 'Permanent Workers having More than Minimum Wage',
  P5_LABEL_62: '% of Permanent Workers having More than Minimum Wage',

  P5_LABEL_63: 'Other than Permanent Employees having Equal to Minimum Wage',
  P5_LABEL_64:
    '% of Other than Permanent Employees having Equal to Minimum Wage',
  P5_LABEL_65: 'Other than Permanent Employees having More than Minimum Wage',
  P5_LABEL_66:
    '% of Other than Permanent Employees having More than Minimum Wage',

  P5_LABEL_67: 'Other than Permanent Workers having Equal to Minimum Wage',
  P5_LABEL_68: '% of Other than Permanent Workers having Equal to Minimum Wage',
  P5_LABEL_69: 'Other than Permanent Workers having More than Minimum Wage',
  P5_LABEL_70:
    '% of Other than Permanent Workers having More than Minimum Wage',
  P5_LABEL_71: 'Total Employees',
  P5_LABEL_72: 'Total Workers'
};

// principle6----------------------------------
export const Principle6Key = {
  P6_QUESTION_1: 'p6Question1',
  P6_QUESTION_1_1: 'p6Question1_1',
  P6_QUESTION_2: 'p6Question2',
  P6_QUESTION_3_1: 'p6Question3_1',
  P6_QUESTION_3: 'p6Question3',
  P6_QUESTION_4: 'p6Question4',
  P6_QUESTION_5_1: 'p6Question5_1',
  P6_QUESTION_5: 'p6Question5',
  P6_QUESTION_6: 'p6Question6',
  P6_QUESTION_7: 'p6Question7',
  P6_QUESTION_8: 'p6Question8',
  P6_QUESTION_9_1: 'p6Question9_1',
  P6_QUESTION_9: 'p6Question9',
  P6_QUESTION_10: 'p6Question10',

  P6_QUESTION_11_1: 'p6Question11_1',
  P6_QUESTION_11: 'p6Question11',
  P6_QUESTION_12: 'p6Question12',
  P6_QUESTION_13_1: 'p6Question13_1',
  P6_QUESTION_13: 'p6Question13',
  P6_QUESTION_14: 'p6Question14',
  P6_QUESTION_15: 'p6Question15',
  P6_QUESTION_16: 'p6Question16',
  P6_QUESTION_17: 'p6Question17',
  P6_QUESTION_18: 'p6Question18',
  P6_QUESTION_19: 'p6Question19',
  P6_QUESTION_19_1: 'p6Question19_1',
  P6_QUESTION_19_2: 'p6Question19_2',
  P6_QUESTION_19_3: 'p6Question19_3',
  P6_QUESTION_20: 'p6Question20',
  P6_QUESTION_20_1: 'p6Question20_1',
  P6_QUESTION_20_2: 'p6Question20_2',
  P6_QUESTION_20_3: 'p6Question20_3',

  P6_QUESTION_21: 'p6Question21',
  P6_QUESTION_22: 'p6Question22',
  P6_QUESTION_23: 'p6Question23',
  P6_QUESTION_24: 'p6Question24',
  P6_QUESTION_25: 'p6Question25',
  P6_QUESTION_26: 'p6Question26',
  P6_QUESTION_27: 'p6Question27',
  P6_QUESTION_28: 'p6Question28',
  P6_QUESTION_29: 'p6Question29',
  P6_QUESTION_30: 'p6Question30',

  P6_QUESTION_31: 'p6Question31',
  P6_QUESTION_32: 'p6Question32',
  P6_QUESTION_33: 'p6Question33',
  P6_QUESTION_34: 'p6Question34',
  P6_QUESTION_35: 'p6Question35',
  P6_QUESTION_36: 'p6Question36',
  P6_QUESTION_37: 'p6Question37',
  P6_QUESTION_38: 'p6Question38',
  P6_QUESTION_39: 'p6Question39',
  P6_QUESTION_40: 'p6Question40',

  P6_QUESTION_41_1: 'p6Question41_1',
  P6_QUESTION_41: 'p6Question41',
  P6_QUESTION_42_1: 'p6Question42_1',
  P6_QUESTION_42: 'p6Question42',
  P6_QUESTION_43_1: 'p6Question43_1',
  P6_QUESTION_43: 'p6Question43',
  P6_QUESTION_44_1: 'p6Question44_1',
  P6_QUESTION_44: 'p6Question44',
  P6_QUESTION_45: 'p6Question45',
  P6_QUESTION_46: 'p6Question46',
  P6_QUESTION_47: 'p6Question47',
  P6_QUESTION_48: 'p6Question48',
  P6_QUESTION_49: 'p6Question49',
  P6_QUESTION_50: 'p6Question50',

  P6_QUESTION_51: 'p6Question51',
  P6_QUESTION_52: 'p6Question52',
  P6_QUESTION_53: 'p6Question53',
  P6_QUESTION_54: 'p6Question54',
  P6_QUESTION_55: 'p6Question55',
  P6_QUESTION_56: 'p6Question56',
  P6_QUESTION_57: 'p6Question57',
  P6_QUESTION_58: 'p6Question58',
  P6_QUESTION_59: 'p6Question59',
  P6_QUESTION_60: 'p6Question60',

  P6_QUESTION_61: 'p6Question61',
  P6_QUESTION_62: 'p6Question62',
  P6_QUESTION_63: 'p6Question63',
  P6_QUESTION_64: 'p6Question64',
  P6_QUESTION_65: 'p6Question65',
  P6_QUESTION_66: 'p6Question66',
  P6_QUESTION_67: 'p6Question67',
  P6_QUESTION_68: 'p6Question68',
  P6_QUESTION_69: 'p6Question69',
  P6_QUESTION_70: 'p6Question70',

  P6_QUESTION_71: 'p6Question71',
  P6_QUESTION_72: 'p6Question72',
  P6_QUESTION_73: 'p6Question73',
  P6_QUESTION_74: 'p6Question74',
  P6_QUESTION_75: 'p6Question75',
  P6_QUESTION_76: 'p6Question76',
  P6_QUESTION_77: 'p6Question77',
  P6_QUESTION_78: 'p6Question78',
  P6_QUESTION_79: 'p6Question79',
  P6_QUESTION_80: 'p6Question80',

  P6_QUESTION_81: 'p6Question81',
  P6_QUESTION_82: 'p6Question82',
  P6_QUESTION_83: 'p6Question83',
  P6_QUESTION_84: 'p6Question84',
  P6_QUESTION_85: 'p6Question85',
  P6_QUESTION_86: 'p6Question86',
  P6_QUESTION_87: 'p6Question87',
  P6_QUESTION_88: 'p6Question88',
  P6_QUESTION_89: 'p6Question89',
  P6_QUESTION_90: 'p6Question90',

  P6_QUESTION_91: 'p6Question91',
  P6_QUESTION_92_1: 'p6Question92_1',
  P6_QUESTION_92: 'p6Question92',
  P6_QUESTION_93: 'p6Question93',
  P6_QUESTION_94: 'p6Question94',
  P6_QUESTION_95: 'p6Question95',
  P6_QUESTION_96: 'p6Question96',
  P6_QUESTION_97: 'p6Question97',
  P6_QUESTION_98: 'p6Question98',
  P6_QUESTION_99: 'p6Question99',
  P6_QUESTION_100: 'p6Question100',

  P6_QUESTION_101: 'p6Question101',
  P6_QUESTION_102: 'p6Question102',
  P6_QUESTION_103: 'p6Question103',
  P6_QUESTION_104: 'p6Question104',
  P6_QUESTION_105: 'p6Question105',
  P6_QUESTION_106: 'p6Question106',
  P6_QUESTION_107: 'p6Question107',
  P6_QUESTION_108: 'p6Question108',
  P6_QUESTION_109: 'p6Question109',
  P6_QUESTION_110: 'p6Question110',

  P6_QUESTION_111: 'p6Question111',
  P6_QUESTION_112: 'p6Question112',
  P6_QUESTION_113: 'p6Question113',
  P6_QUESTION_114: 'p6Question114',
  P6_QUESTION_115: 'p6Question115',
  P6_QUESTION_116: 'p6Question116',
  P6_QUESTION_117: 'p6Question117',
  P6_QUESTION_118: 'p6Question118',
  P6_QUESTION_119: 'p6Question119',
  P6_QUESTION_120: 'p6Question120',

  P6_QUESTION_121: 'p6Question121',
  P6_QUESTION_122: 'p6Question122',
  P6_QUESTION_123: 'p6Question123',
  P6_QUESTION_124: 'p6Question124',
  P6_QUESTION_125: 'p6Question125',
  P6_QUESTION_126: 'p6Question126',
  P6_QUESTION_127: 'p6Question127',
  P6_QUESTION_128: 'p6Question128',
  P6_QUESTION_129: 'p6Question129',
  P6_QUESTION_130: 'p6Question130',

  P6_QUESTION_131: 'p6Question131',
  P6_QUESTION_132: 'p6Question132',
  P6_QUESTION_133_1: 'p6Question133_1',
  P6_QUESTION_133: 'p6Question133',
  P6_QUESTION_134: 'p6Question134',
  P6_QUESTION_135: 'p6Question135',
  P6_QUESTION_136_1: 'p6Question136_1',
  P6_QUESTION_136: 'p6Question136',
  P6_QUESTION_137: 'p6Question137',
  P6_QUESTION_138: 'p6Question138',
  P6_QUESTION_139: 'p6Question139',
  P6_QUESTION_140: 'p6Question140',

  P6_QUESTION_141: 'p6Question141',
  P6_QUESTION_142_1: 'p6Question142_1',
  P6_QUESTION_142: 'p6Question142',
  P6_QUESTION_143: 'p6Question143',
  P6_QUESTION_144: 'p6Question144',
  P6_QUESTION_145_1: 'p6Question145_1',
  P6_QUESTION_145: 'p6Question145',
  P6_QUESTION_146: 'p6Question146',
  P6_QUESTION_147: 'p6Question147',
  P6_QUESTION_148: 'p6Question148',
  P6_QUESTION_149: 'p6Question149',
  P6_QUESTION_150: 'p6Question150',

  P6_QUESTION_151: 'p6Question151',
  P6_QUESTION_152: 'p6Question152',
  P6_QUESTION_153: 'p6Question153',
  P6_QUESTION_154: 'p6Question154',
  P6_QUESTION_155: 'p6Question155',
  P6_QUESTION_156: 'p6Question156',
  P6_QUESTION_157: 'p6Question157',
  P6_QUESTION_158: 'p6Question158',
  P6_QUESTION_159: 'p6Question159',
  P6_QUESTION_160: 'p6Question160',

  P6_QUESTION_161: 'p6Question161',
  P6_QUESTION_162: 'p6Question162',
  P6_QUESTION_162_1: 'p6Question162_1',
  P6_QUESTION_163: 'p6Question163',
  P6_QUESTION_164: 'p6Question164',
  P6_QUESTION_165: 'p6Question165',
  P6_QUESTION_166: 'p6Question166',
  P6_QUESTION_167: 'p6Question167',
  P6_QUESTION_167_1: 'p6Question167_1',
  P6_QUESTION_168: 'p6Question168',
  P6_QUESTION_169: 'p6Question169',
  P6_QUESTION_170_1: 'p6Question170_1',
  P6_QUESTION_170: 'p6Question170',

  P6_QUESTION_171: 'p6Question171',
  P6_QUESTION_172: 'p6Question172',
  P6_QUESTION_173: 'p6Question173',
  P6_QUESTION_174: 'p6Question174',
  P6_QUESTION_175: 'p6Question175',
  P6_QUESTION_176: 'p6Question176',
  P6_QUESTION_177: 'p6Question177',
  P6_QUESTION_177_value: 'p6Question177_value',
  P6_QUESTION_177_1: 'p6Question177_1',
  P6_QUESTION_178: 'p6Question178',
  P6_QUESTION_179: 'p6Question179',
  P6_QUESTION_180: 'p6Question180',

  P6_QUESTION_181: 'p6Question181',
  P6_QUESTION_182: 'p6Question182',
  P6_QUESTION_183: 'p6Question183',
  P6_QUESTION_184: 'p6Question184',
  P6_QUESTION_185: 'p6Question185',
  P6_QUESTION_186: 'p6Question186',
  P6_QUESTION_187: 'p6Question187',
  P6_QUESTION_188: 'p6Question188',
  P6_QUESTION_189: 'p6Question189',
  P6_QUESTION_190: 'p6Question190',

  P6_QUESTION_191: 'p6Question191',
  P6_QUESTION_192_1: 'p6Question192_1',
  P6_QUESTION_192: 'p6Question192',
  P6_QUESTION_193: 'p6Question193',
  P6_QUESTION_194: 'p6Question194',
  P6_QUESTION_195: 'p6Question195',
  P6_QUESTION_196: 'p6Question196',
  P6_QUESTION_197: 'p6Question197',
  P6_QUESTION_198_1: 'p6Question198_1',
  P6_QUESTION_198: 'p6Question198',
  P6_QUESTION_199_1: 'p6Question199_1',
  P6_QUESTION_199: 'p6Question199',
  P6_QUESTION_200: 'p6Question200',

  P6_QUESTION_201: 'p6Question201',
  P6_QUESTION_202: 'p6Question202',
  P6_QUESTION_203: 'p6Question203',
  P6_QUESTION_204: 'p6Question204',
  P6_QUESTION_205: 'p6Question205',
  P6_QUESTION_206: 'p6Question206',
  P6_QUESTION_207: 'p6Question207',
  P6_QUESTION_208: 'p6Question208',
  P6_QUESTION_209: 'p6Question209',
  P6_QUESTION_210: 'p6Question210',

  P6_QUESTION_211: 'p6Question211',
  P6_QUESTION_212: 'p6Question212',
  P6_QUESTION_213: 'p6Question213',
  P6_QUESTION_214: 'p6Question214',
  P6_QUESTION_215: 'p6Question215',
  P6_QUESTION_216: 'p6Question216',
  P6_QUESTION_217: 'p6Question217',
  P6_QUESTION_218_1: 'p6Question218_1',
  P6_QUESTION_218: 'p6Question218',
  P6_QUESTION_219: 'p6Question219',
  P6_QUESTION_220: 'p6Question220',

  P6_QUESTION_221: 'p6Question221',
  P6_QUESTION_222: 'p6Question222',
  P6_QUESTION_223: 'p6Question223',
  P6_QUESTION_224: 'p6Question224',
  P6_QUESTION_225: 'p6Question225',
  P6_QUESTION_226: 'p6Question226',
  P6_QUESTION_227: 'p6Question227',
  P6_QUESTION_228: 'p6Question228',
  P6_QUESTION_229: 'p6Question229',
  P6_QUESTION_230: 'p6Question230',

  P6_QUESTION_231: 'p6Question231',
  P6_QUESTION_232: 'p6Question232',
  P6_QUESTION_233: 'p6Question233',
  P6_QUESTION_234: 'p6Question234',
  P6_QUESTION_235: 'p6Question235',
  P6_QUESTION_236: 'p6Question236',
  P6_QUESTION_237: 'p6Question237',
  P6_QUESTION_238: 'p6Question238',
  P6_QUESTION_239: 'p6Question239',
  P6_QUESTION_240: 'p6Question240',

  P6_QUESTION_241: 'p6Question241',
  P6_QUESTION_242: 'p6Question242',
  P6_QUESTION_243: 'p6Question243',
  P6_QUESTION_244: 'p6Question244',
  P6_QUESTION_245: 'p6Question245',
  P6_QUESTION_246: 'p6Question246',
  P6_QUESTION_247: 'p6Question247',
  P6_QUESTION_248: 'p6Question248',
  P6_QUESTION_249: 'p6Question249',
  P6_QUESTION_250: 'p6Question250',

  P6_QUESTION_251: 'p6Question251',
  P6_QUESTION_252: 'p6Question252',
  P6_QUESTION_253: 'p6Question253',
  P6_QUESTION_254: 'p6Question254',
  P6_QUESTION_255: 'p6Question255',
  P6_QUESTION_256: 'p6Question256',
  P6_QUESTION_257: 'p6Question257',
  P6_QUESTION_258: 'p6Question258',
  P6_QUESTION_259: 'p6Question259',
  P6_QUESTION_260: 'p6Question260',

  P6_QUESTION_261: 'p6Question261',
  P6_QUESTION_262: 'p6Question262',
  P6_QUESTION_263: 'p6Question263',
  P6_QUESTION_264: 'p6Question264',
  P6_QUESTION_265: 'p6Question265',
  P6_QUESTION_266: 'p6Question266',
  P6_QUESTION_267: 'p6Question267',
  P6_QUESTION_268: 'p6Question268',
  P6_QUESTION_269: 'p6Question269',
  P6_QUESTION_270: 'p6Question270',

  P6_QUESTION_271: 'p6Question271',
  P6_QUESTION_272: 'p6Question272',
  P6_QUESTION_273: 'p6Question273',
  P6_QUESTION_274: 'p6Question274',
  P6_QUESTION_275: 'p6Question275',
  P6_QUESTION_276: 'p6Question276',
  P6_QUESTION_277: 'p6Question277',
  P6_QUESTION_278: 'p6Question278',
  P6_QUESTION_279: 'p6Question279',
  P6_QUESTION_280: 'p6Question280',

  P6_QUESTION_281: 'p6Question281',
  P6_QUESTION_282: 'p6Question282',
  P6_QUESTION_283: 'p6Question283',
  P6_QUESTION_284: 'p6Question284',
  P6_QUESTION_285: 'p6Question285',
  P6_QUESTION_286: 'p6Question286',
  P6_QUESTION_287: 'p6Question287',
  P6_QUESTION_288: 'p6Question288',
  P6_QUESTION_289: 'p6Question289',
  P6_QUESTION_290: 'p6Question290',

  P6_QUESTION_291: 'p6Question291',
  P6_QUESTION_292: 'p6Question292',
  P6_QUESTION_293: 'p6Question293',
  P6_QUESTION_294: 'p6Question294',
  P6_QUESTION_295: 'p6Question295',
  P6_QUESTION_296: 'p6Question296',
  P6_QUESTION_297: 'p6Question297',
  P6_QUESTION_298: 'p6Question298',
  P6_QUESTION_299: 'p6Question299',
  P6_QUESTION_300: 'p6Question300',

  P6_QUESTION_301: 'p6Question301',
  P6_QUESTION_302: 'p6Question302',
  P6_QUESTION_303: 'p6Question303',
  P6_QUESTION_304: 'p6Question304',
  P6_QUESTION_305: 'p6Question305',
  P6_QUESTION_306: 'p6Question306',
  P6_QUESTION_307: 'p6Question307',
  P6_QUESTION_308: 'p6Question308',
  P6_QUESTION_309: 'p6Question309',
  P6_QUESTION_310: 'p6Question310',

  P6_QUESTION_311: 'p6Question311',
  P6_QUESTION_312: 'p6Question312',
  P6_QUESTION_313: 'p6Question313',
  P6_QUESTION_314: 'p6Question314',
  P6_QUESTION_315: 'p6Question315',
  P6_QUESTION_316: 'p6Question316',
  P6_QUESTION_317: 'p6Question317',
  P6_QUESTION_318: 'p6Question318',
  P6_QUESTION_319: 'p6Question319',
  P6_QUESTION_320: 'p6Question320',

  P6_QUESTION_321: 'p6Question321',
  P6_QUESTION_322: 'p6Question322',
  P6_QUESTION_323: 'p6Question323',
  P6_QUESTION_324: 'p6Question324',
  P6_QUESTION_325: 'p6Question325',
  P6_QUESTION_326: 'p6Question326',
  P6_QUESTION_327: 'p6Question327',
  P6_QUESTION_328: 'p6Question328',
  P6_QUESTION_329: 'p6Question329',
  P6_QUESTION_330: 'p6Question330',

  P6_QUESTION_331: 'p6Question331',
  P6_QUESTION_332: 'p6Question332',
  P6_QUESTION_333: 'p6Question333',
  P6_QUESTION_334: 'p6Question334',
  P6_QUESTION_335: 'p6Question335',
  P6_QUESTION_336: 'p6Question336',
  P6_QUESTION_337: 'p6Question337',
  P6_QUESTION_338: 'p6Question338',
  P6_QUESTION_339: 'p6Question339',
  P6_QUESTION_340: 'p6Question340',

  P6_QUESTION_341: 'p6Question341',
  P6_QUESTION_342: 'p6Question342',
  P6_QUESTION_343: 'p6Question343',
  P6_QUESTION_344: 'p6Question344',
  P6_QUESTION_345: 'p6Question345',
  P6_QUESTION_346: 'p6Question346',
  P6_QUESTION_347: 'p6Question347',
  P6_QUESTION_348: 'p6Question348',
  P6_QUESTION_349: 'p6Question349',
  P6_QUESTION_350: 'p6Question350',

  P6_QUESTION_351: 'p6Question351',
  P6_QUESTION_352: 'p6Question352',
  P6_QUESTION_353: 'p6Question353',
  P6_QUESTION_354: 'p6Question354',
  P6_QUESTION_355: 'p6Question355',
  P6_QUESTION_356: 'p6Question356',
  P6_QUESTION_357: 'p6Question357',
  P6_QUESTION_358: 'p6Question358',
  P6_QUESTION_359: 'p6Question359',
  P6_QUESTION_360: 'p6Question360',
  P6_QUESTION_361: 'p6Question361',
  P6_QUESTION_362: 'p6Question362',
  P6_QUESTION_363: 'p6Question363',
  P6_QUESTION_364: 'p6Question364',
  P6_QUESTION_365: 'p6Question365',
  P6_QUESTION_366: 'p6Question366',
  P6_QUESTION_367: 'p6Question367',
  P6_QUESTION_368: 'p6Question368',
  P6_QUESTION_369: 'p6Question369',
  P6_QUESTION_370: 'p6Question370',
  P6_QUESTION_371: 'p6Question371',
  P6_QUESTION_372: 'p6Question372',
  P6_QUESTION_373: 'p6Question373',
  P6_QUESTION_374: 'p6Question374',
  P6_QUESTION_375: 'p6Question375',
  P6_QUESTION_376: 'p6Question376',
  P6_QUESTION_377: 'p6Question377',
  P6_QUESTION_378: 'p6Question378',
  P6_QUESTION_379: 'p6Question379',

  P6_QUESTION_380: 'p6Question380',
  P6_QUESTION_381: 'p6Question381',
  P6_QUESTION_382: 'p6Question382',

  P6_QUESTION_383: 'p6Question383',
  P6_QUESTION_384: 'p6Question384'
};

export const Principle6Label = {
  P6_HEADING_1:
    'Businesses should respect and make efforts to protect and restore the environment',
  P6_HEADINGLABEL_1: 'Essential Indicators',
  P6_HEADINGLABEL_2: 'Leadership Indicators',

  P6_QUESTION_1:
    '1. Details of total energy consumption (in Joules or multiples) and energy intensity, in the following format:',
  P6_QUESTION_2:
    '2. Does the entity have any sites / facilities identified as designated consumers (DCs) under the Performance, Achieve and Trade (PAT) Scheme of the Government of India? (Y/N) If yes, disclose whether targets set under the PAT scheme have been achieved. In case targets have not been achieved, provide the remedial action taken, if any.',
  P6_QUESTION_3:
    '3. Provide details of the following disclosures related to water, in the following format:',
  P6_QUESTION_4:
    '4. Provide the following details related to water discharged:',
  P6_QUESTION_5:
    '5. Has the entity implemented a mechanism for Zero Liquid Discharge? If yes, provide details of its coverage and implementation.',
  P6_QUESTION_6:
    '6. Please provide details of air emissions (other than GHG emissions) by the entity, in the following format:',
  P6_QUESTION_7:
    '7. Provide details of greenhouse gas emissions (Scope 1 and Scope 2 emissions) & its intensity, in the following format:',
  P6_QUESTION_8:
    '8. Does the entity have any project related to reducing Green House Gas emission? If Yes, then provide details.',
  P6_QUESTION_9:
    '9. Provide details related to waste management by the entity, in the following format:',
  P6_QUESTION_10:
    '10. Briefly describe the waste management practices adopted in your establishments. Describe the strategy adopted by your company to reduce usage of hazardous and toxic chemicals in your products and processes and the practices adopted to manage such wastes.',
  P6_QUESTION_11:
    '11. If the entity has operations/offices in/around ecologically sensitive areas (such as national parks,  wildlife  sanctuaries,  biosphere  reserves,  wetlands,  biodiversity  hotspots,  forests, coastal regulation zones etc.) where environmental approvals / clearances are required, please specify details in the following format:',
  P6_QUESTION_12: `12. Details of environmental impact assessments of projects undertaken by the entity based on applicable laws, in the ${FY.current}:`,
  P6_QUESTION_13:
    '13. Is the entity compliant with the applicable environmental law/ regulations/ guidelines in India. such as the Water (Prevention and Control of Pollution) Act, Air (Prevention and Control of Pollution) Act, Environment protection act and rules thereunder (Y/N). If not, provide details of all such non-compliances, in the following format:',
  P6_QUESTION_14:
    '1. Water withdrawal, consumption and discharge in areas of water stress (in kilolitres):',
  P6_QUESTION_15:
    '2. Please provide details of total Scope 3 emissions & its intensity, in the following format:',
  P6_QUESTION_16:
    '3. With respect to the ecologically sensitive areas reported at Question 11 of Essential Indicators above, provide details of significant direct & indirect impact of the entity on biodiversity in such areas along-with prevention and remediation activities.',
  P6_QUESTION_17:
    '4. If the entity has undertaken any specific initiatives or used innovative technology or solutions to improve resource efficiency, or reduce impact due to emissions / effluent discharge / waste generated, please provide details of the same as well as outcome of such initiatives, as per the following format:',
  P6_QUESTION_18:
    '5. Does the entity have a business continuity and disaster management plan? Give details in 100 words/ web link.',
  P6_QUESTION_19:
    '6. Disclose any significant adverse impact to the environment, arising from the value chain of the entity. What mitigation or adaptation measures have been taken by the entity in this regard.',
  P6_QUESTION_20:
    '7. Percentage of value chain partners (by value of business done with such partners) that were assessed for environmental impacts.',
  P6_HEADING_3:
    'For each facility / plant located in areas of water stress, provide the following information',
  P6_HEADING_4: `In ( ${FY.current} )`,
  P6_HEADING_5: `In ( ${FY.previous} )`,

  P6_HEADING_6: 'From renewable sources',
  P6_HEADING_7: 'Total electricity consumption (A)',
  P6_HEADING_8: 'Total fuel consumption (B)',
  P6_HEADING_9: 'Energy consumption through other sources (C)',
  P6_HEADING_10: `Total energy consumed from renewable sources In ( ${FY.current} )`,

  P6_HEADING_11: 'From Non-renewable sources',
  P6_HEADING_12: 'Total electricity consumption (D)',
  P6_HEADING_13: 'Total fuel consumption (E)',
  P6_HEADING_14: 'Energy consumption through other sources (F)',
  P6_HEADING_15: 'Total energy consumed from non renewable sources (D+E+F)',

  P6_HEADING_16: 'Total energy consumed (A+B+C+D+E+F)',
  P6_HEADING_17:
    'Energy intensity per rupee of turnover (Total energy consumption/ Turnover in rupees)',
  P6_HEADING_18: 'Energy intensity in terms of physical output',
  P6_HEADING_19:
    'Energy intensity (optional) - the relevant metric may be selected by the entity',
  P6_HEADING_20:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',

  P6_HEADING_21: 'Water withdrawal by source (in kilolitres)',
  P6_HEADING_22: 'i. Surface water',
  P6_HEADING_23: 'ii. Groundwater',
  P6_HEADING_24: 'iii. Third party water',
  P6_HEADING_25: 'iv. Seawater / desalinated water',
  P6_HEADING_26: 'v. Others',
  P6_HEADING_27:
    'Total volume of water withdrawal (in kilolitres) (i + ii + iii + iv + v)',
  P6_HEADING_28: 'Total volume of water consumption (in kilolitres)',
  P6_HEADING_29:
    'Water intensity per rupee of turnover (Total water consumption / Revenue from operations)',
  P6_HEADING_30:
    'Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) (Total water consumption / Revenue from operations adjusted for PPP)',
  P6_HEADING_31: 'Water intensity in terms of physical output',
  P6_HEADING_32:
    'Water intensity (optional) - the relevant metric may be selected by the entity',
  P6_HEADING_33:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',

  P6_HEADING_34:
    'Water discharge by destination and level of treatment (in kilolitres)',
  P6_HEADING_35: 'i. Into Surface water',
  P6_HEADING_36: 'ii. Into Groundwater',
  P6_HEADING_37: 'iii. Into Seawater',
  P6_HEADING_38: 'iv. Sent to third-parties',
  P6_HEADING_39: 'v. Others',
  P6_HEADING_40: 'No treatment',
  P6_HEADING_41: 'With treatment - please specify level of treatment',
  P6_HEADING_42: 'Total water discharged (in kilolitres)',
  P6_HEADING_43:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency',

  P6_HEADING_44: 'a. NOx',
  P6_HEADING_45: 'b. SOx',
  P6_HEADING_46: 'c. Particulate matter (PM)',
  P6_HEADING_47: 'd. Persistent organic pollutants (POP)',
  P6_HEADING_48: 'e. Volatile organic compounds (VOC)',
  P6_HEADING_49: 'f. Hazardous air pollutants (HAP)',
  P6_HEADING_50: 'g. Others - please specify',
  P6_HEADING_50_1: 'Others - please specify',
  P6_HEADING_51:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',

  P6_HEADING_52:
    'Total Scope 1 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)',
  P6_HEADING_53:
    'Total Scope 2 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)',
  P6_HEADING_54:
    'Total Scope 1 and Scope 2 emission intensity per rupee of turnover (Total Scope 1 and Scope 2 GHG emissions / Revenue from operations)',
  P6_HEADING_55:
    'Total Scope 1 and Scope 2  emissions intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) (Total Scope 1 and Scope 2 GHG emissions / Revenue from operations adjusted for PPP)',
  P6_HEADING_57:
    'Total Scope 1 and Scope 2 emission intensity in terms of physical output',
  P6_HEADING_58:
    'Total Scope 1 and Scope 2 emission intensity (optional) - the relevant metric may be selected by the entity',
  P6_HEADING_59:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',

  P6_HEADING_60: 'Total Waste generated (in metric tonnes)',
  P6_HEADING_61: 'a. Plastic waste',
  P6_HEADING_62: 'b. E-waste',
  P6_HEADING_63: 'c. Bio-medical waste',
  P6_HEADING_64: 'd. Construction and demolition waste',
  P6_HEADING_65: 'e. Battery waste',
  P6_HEADING_66: 'f. Radioactive waste',
  P6_HEADING_67: 'g. Other Hazardous waste. Please specify, if any.',
  P6_HEADING_68:
    'Other Non-hazardous waste generated (H). Please specify, if any. (Break-up  by  composition  i.e. by materials relevant to the sector)',
  P6_HEADING_69: 'Total (A+B + C + D + E + F + G + H)',

  P6_HEADING_70:
    'Waste intensity per rupee of turnover (Total waste generated / Revenue from operations)',
  P6_HEADING_71:
    'Waste intensity per rupee of turnover adjusted for  Purchasing Power Parity (PPP) (Total waste generated / Revenue from operations  adjusted for PPP)',
  P6_HEADING_72: 'Waste intensity in terms of physical output',
  P6_HEADING_73:
    'Waste intensity (optional) - the relevant metric may be selected by the entity',
  P6_HEADING_74:
    'For each category of waste generated, total waste recovered through recycling, re-using or other recovery operations (in metric tonnes)',
  P6_HEADING_75: 'i. Recycled',
  P6_HEADING_76: 'ii. Re-used',
  P6_HEADING_77: 'iii. Other recovery operations',
  P6_HEADING_78:
    'For each category of waste generated, total waste disposed by nature of disposal method (in metric tonnes)',
  P6_HEADING_79: 'i. Incineration',
  P6_HEADING_80: 'ii. Landfilling',
  P6_HEADING_81: 'iii. Other disposal operations',
  P6_HEADING_82:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',
  P6_HEADING_83: 'Total',
  P6_HEADING_84: 'Category of waste',

  P6_HEADING_85: 'Location of operations / offices',
  P6_HEADING_86: 'Type of operations',
  P6_HEADING_87:
    'Whether the conditions of environmental approval / clearance are being complied with? (Y/N) If no, the reasons thereof and corrective action taken, if any.',

  P6_HEADING_88: 'Name and brief details of project',
  P6_HEADING_89: 'EIA Notification No.',
  P6_HEADING_90: 'Date',
  P6_HEADING_91: 'Whether conducted by independent external agency (Yes / No)',
  P6_HEADING_92: 'Results communicated in public domain (Yes / No)',
  P6_HEADING_93: 'Relevant Web link',

  P6_HEADING_94:
    'Specify the law / regulation / guidelines which was not complied with',
  P6_HEADING_95: 'Provide details of the non- compliance',
  P6_HEADING_96:
    'Any fines / penalties / action taken by regulatory agencies such as pollution control boards or by courts',
  P6_HEADING_97: 'Corrective action taken, if any',
  P6_HEADING_98:
    'For each facility / plant located in areas of water stress, provide the following information:',
  P6_HEADING_99: 'i. Name of the area :',
  P6_HEADING_100: 'ii. Nature of operations :',
  P6_HEADING_101:
    'iii. Water withdrawal, consumption and discharge in the following format',

  P6_HEADING_102: 'Total volume of water consumption (in kilolitres)',
  P6_HEADING_103:
    'Water intensity per rupee of turnover (Water consumed / turnover)',

  P6_HEADING_104:
    'Total Scope 3 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)',
  P6_HEADING_105: 'Total turnover in rupees',
  P6_HEADING_106:
    'Total Scope 3 emission intensity (optional) - the relevant metric may be selected by the entity',
  P6_HEADING_107:
    'Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N) If yes, name of the external agency.',

  P6_HEADING_108: 'Initiative undertaken',
  P6_HEADING_109:
    'Details of the initiative (Web-link, if any, may be provided along-with summary)',
  P6_HEADING_110: 'Outcome of the initiative',
  P6_HEADING_111:
    'Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) (Total energy consumed / Revenue from operations adjusted for PPP)',

  P6_LABEL_1: `In ( ${FY.current} )`,
  P6_LABEL_2: `In ( ${FY.previous} )`,
  P6_LABEL_3: 'Please specify unit',
  P6_LABEL_4: 'Total energy consumption',
  P6_LABEL_5: 'Turnover in rupees',
  P6_LABEL_6: 'Total Scope 1 and Scope 2 GHG emissions',
  P6_LABEL_7: 'Revenue from operations',
  P6_LABEL_9: 'Total waste generated',
  P6_LABEL_10: 'Revenue from operations',
  P6_LABEL_11: 'Revenue from operations adjusted for PPP',
  P6_LABEL_12: 'N/A',
  P6_LABEL_13: 'Water consumed',
  P6_LABEL_14: 'Turnover',
  P6_LABEL_15: 'Total energy consumed',
  P6_LABEL_16: 'Revenue from operations adjusted for PPP',
  P6_LABEL_17: 'Total water consumption',
  P6_LABEL_18: 'Revenue from operations',
  P6_LABEL_19: 'Total water consumption',
  P6_LABEL_20: 'Revenue from operations adjusted for PPP',
  P6_LABEL_21: '1)',
  P6_LABEL_22: `Total energy consumed In ( ${FY.current} )`,
  P6_LABEL_23: `Total energy consumed In ( ${FY.previous} )`,
  P6_LABEL_24: `Total Renewable energy consumed In ( ${FY.current} )`,
  P6_LABEL_25: `Total Renewable energy consumed In ( ${FY.previous} )`,
  P6_LABEL_26: `Total Non-renewable consumed In ( ${FY.current} )`,
  P6_LABEL_27: `Total Non-renewable consumed In ( ${FY.previous} )`,
  P6_LABEL_28: `Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.current} )`,
  P6_LABEL_29: `Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.previous} )`,
  P6_LABEL_30: `Energy intensity per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_31: `Energy intensity per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_32: `Total volume of Water withdrawal by source (in kilolitres) In ( ${FY.current} )`,
  P6_LABEL_33: `Total volume of Water withdrawal by source (in kilolitres) In ( ${FY.previous} )`,
  P6_LABEL_34: `Water intensity per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_35: `Water intensity per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_36: `Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.current} )`,
  P6_LABEL_37: `Water intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.previous} )`,
  P6_LABEL_38: `Total Scope 1 and Scope 2 emission intensity per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_39: `Total Scope 1 and Scope 2 emission intensity per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_40: `Total Scope 1 and Scope 2 emission intensity per rupee of turnover for Purchasing Power Parity (PPP) In ( ${FY.current} )`,
  P6_LABEL_41: `Total Scope 1 and Scope 2 emission intensity per rupee of turnover for Purchasing Power Parity (PPP) In ( ${FY.previous} )`,
  P6_LABEL_42: `Total Waste generated In ( ${FY.current} )`,
  P6_LABEL_43: `Total Waste generated In ( ${FY.previous} )`,
  P6_LABEL_44: `Total waste recovered through recycling, re-using or other recovery operations In ( ${FY.current} )`,
  P6_LABEL_45: `Total waste recovered through recycling, re-using or other recovery operations In ( ${FY.previous} )`,
  P6_LABEL_46: `Total waste disposed by nature of disposal method In ( ${FY.current} )`,
  P6_LABEL_47: `Total waste disposed by nature of disposal method In ( ${FY.previous} )`,
  P6_LABEL_48: `Waste intensity per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_49: `Waste intensity per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_50: `Waste intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.current} )`,
  P6_LABEL_51: `Waste intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP) In ( ${FY.previous} )`,
  P6_LABEL_52: `Total volume of Water withdrawal by source In ( ${FY.current} )`,
  P6_LABEL_53: `Total volume of Water withdrawal by source In ( ${FY.previous} )`,
  P6_LABEL_54: `Water intensity per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_55: `Water intensity per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_56: `Total water discharged (in kilolitres) In ( ${FY.current} )`,
  P6_LABEL_57: `Total water discharged (in kilolitres) In ( ${FY.previous} )`,
  P6_LABEL_58: `Total Scope 3 emissions per rupee of turnover In ( ${FY.current} )`,
  P6_LABEL_59: `Total Scope 3 emissions per rupee of turnover In ( ${FY.previous} )`,
  P6_LABEL_60: `Total water discharged (in kilolitres) In ( ${FY.current} )`,
  P6_LABEL_61: `Total water discharged (in kilolitres) In ( ${FY.previous} )`,
  P6_LABEL_62: 'Other- Please specify',
  P6_LABEL_63: 'Total Scope 3 emissions'
};

// principle7----------------------------------
export const Principle7Key = {
  P7_QUESTION_1: 'p7Question1',
  P7_QUESTION_2: 'p7Question2',
  P7_QUESTION_3: 'p7Question3',
  P7_QUESTION_4: 'p7Question4',
  P7_QUESTION_5: 'p7Question5',
  P7_QUESTION_6: 'p7Question6',
  P7_QUESTION_7: 'p7Question7',
  P7_QUESTION_8: 'p7Question8',
  P7_QUESTION_9: 'p7Question9',

  P7_QUESTION_10: 'p7Question10',
  P7_QUESTION_11: 'p7Question11',
  P7_QUESTION_12: 'p7Question12',
  P7_QUESTION_13: 'p7Question13',
  P7_QUESTION_14: 'p7Question14',
  P7_QUESTION_15: 'p7Question15',
  P7_QUESTION_16: 'p7Question16',
  P7_QUESTION_17: 'p7Question17',
  P7_QUESTION_18: 'p7Question18',
  P7_QUESTION_19: 'p7Question19',
  P7_QUESTION_20: 'p7Question20',

  P7_QUESTION_21: 'p7Question21',
  P7_QUESTION_22: 'p7Question22',
  P7_QUESTION_23: 'p7Question23',
  P7_QUESTION_24: 'p7Question24',
  P7_QUESTION_25: 'p7Question25',
  P7_QUESTION_26: 'p7Question26',
  P7_QUESTION_27: 'p7Question27',
  P7_QUESTION_28: 'p7Question28',
  P7_QUESTION_29: 'p7Question29',
  P7_QUESTION_30: 'p7Question30',

  P7_QUESTION_31_1: 'p7Question31_1',
  P7_QUESTION_31: 'p7Question31',
  P7_QUESTION_32_1: 'p7Question32_1',
  P7_QUESTION_32: 'p7Question32',
  P7_QUESTION_33: 'p7Question33',
  P7_QUESTION_34: 'p7Question34',
  P7_QUESTION_35: 'p7Question35',
  P7_QUESTION_36: 'p7Question36',
  P7_QUESTION_37: 'p7Question37',
  P7_QUESTION_38: 'p7Question38',
  P7_QUESTION_39: 'p7Question39',
  P7_QUESTION_40: 'p7Question40',

  P7_QUESTION_41: 'p7Question41',
  P7_QUESTION_42: 'p7Question42',
  P7_QUESTION_43: 'p7Question43',
  P7_QUESTION_44: 'p7Question44',
  P7_QUESTION_45: 'p7Question45',
  P7_QUESTION_46: 'p7Question46',
  P7_QUESTION_47: 'p7Question47',
  P7_QUESTION_48: 'p7Question48',
  P7_QUESTION_49: 'p7Question49',
  P7_QUESTION_50: 'p7Question50',

  P7_QUESTION_51: 'p7Question51',
  P7_QUESTION_52: 'p7Question52',
  P7_QUESTION_53: 'p7Question53',
  P7_QUESTION_54: 'p7Question54',
  P7_QUESTION_55: 'p7Question55',
  P7_QUESTION_56: 'p7Question56',
  P7_QUESTION_57: 'p7Question57',
  P7_QUESTION_58: 'p7Question58',
  P7_QUESTION_59: 'p7Question59',
  P7_QUESTION_60: 'p7Question60',

  P7_QUESTION_61: 'p7Question61',
  P7_QUESTION_62: 'p7Question62',
  P7_QUESTION_63: 'p7Question63',
  P7_QUESTION_64: 'p7Question64',
  P7_QUESTION_65: 'p7Question65',
  P7_QUESTION_66: 'p7Question66',
  P7_QUESTION_67: 'p7Question67',
  P7_QUESTION_68: 'p7Question68',
  P7_QUESTION_69: 'p7Question69',
  P7_QUESTION_70: 'p7Question70',

  P7_QUESTION_71: 'p7Question71',
  P7_QUESTION_72: 'p7Question72',
  P7_QUESTION_73: 'p7Question73',
  P7_QUESTION_74: 'p7Question74',
  P7_QUESTION_75: 'p7Question75',
  P7_QUESTION_76: 'p7Question76',
  P7_QUESTION_77: 'p7Question77',
  P7_QUESTION_78: 'p7Question78',
  P7_QUESTION_79: 'p7Question79',
  P7_QUESTION_80: 'p7Question80',

  P7_QUESTION_81: 'p7Question81',
  P7_QUESTION_82: 'p7Question82',
  P7_QUESTION_83: 'p7Question83'
};

export const Principle7Label = {
  P7_HEADING_1:
    'Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent',
  P7_HEADINGLABEL_1: 'Essential Indicators',
  P7_HEADINGLABEL_2: 'Leadership Indicators',
  P7_HEADING_4: `In ( ${FY.current} )`,
  P7_HEADING_5: `In ( ${FY.previous} )`,
  P7_HEADING_6: 'Name of the trade and industry chambers/ associations',
  P7_HEADING_7:
    'Reach of trade and industry chambers/ associations (State/National)',
  P7_HEADING_8: 'Name of authority',
  P7_HEADING_9: 'Brief of the case',
  P7_HEADING_10: 'Corrective action taken',

  P7_HEADING_11: 'Public policy advocated',
  P7_HEADING_12: 'Method resorted for such advocacy',
  P7_HEADING_13: 'Whether information available in public domain?',
  P7_HEADING_14:
    'Frequency of Review by Board (Annually/ Half yearly/ Quarterly / Others - please specify)',
  P7_HEADING_15: 'Web Link, if available',
  P7_QUESTION_1:
    '1. a. Number of affiliations with trade and industry chambers/ associations.',
  P7_QUESTION_2:
    'b. List the top 10 trade and industry chambers/ associations (determined based on the total members of such body) the entity is a member of/ affiliated to.',
  P7_QUESTION_3:
    '2. Provide details of corrective action taken or underway on any issues related to anti- competitive conduct by the entity, based on adverse orders from regulatory authorities.',
  P7_QUESTION_4:
    '1. Details of public policy positions advocated by the entity:',

  P7_LABEL_1: `In ( ${FY.current} )`,
  P7_LABEL_2: `In ( ${FY.previous} )`,

  P7_LABEL_3: '1)',
  P7_LABEL_4: '2)',
  P7_LABEL_5: '3)',
  P7_LABEL_6: '4)',
  P7_LABEL_7: '5)',
  P7_LABEL_8: '6)',
  P7_LABEL_9: '7)',
  P7_LABEL_10: '8)',
  P7_LABEL_11: '9)',
  P7_LABEL_12: '10)',
  P7_LABEL_13: 'N/A'
};

// principle8----------------------------------
export const Principle8Key = {
  P8_QUESTION_1: 'p8Question1',
  P8_QUESTION_1_1: 'p8Question1_1',
  P8_QUESTION_2: 'p8Question2',
  P8_QUESTION_3: 'p8Question3',
  P8_QUESTION_4: 'p8Question4',
  P8_QUESTION_5: 'p8Question5',
  P8_QUESTION_6: 'p8Question6',
  P8_QUESTION_7: 'p8Question7',
  P8_QUESTION_7_1: 'p8Question7_1',
  P8_QUESTION_8: 'p8Question8',
  P8_QUESTION_9: 'p8Question9',

  P8_QUESTION_10: 'p8Question10',
  P8_QUESTION_11: 'p8Question11',
  P8_QUESTION_12: 'p8Question12',
  P8_QUESTION_13: 'p8Question13',
  P8_QUESTION_14_1: 'p8Question14_1',
  P8_QUESTION_14: 'p8Question14',
  P8_QUESTION_15: 'p8Question15',
  P8_QUESTION_16_1: 'p8Question16_1',
  P8_QUESTION_16: 'p8Question16',
  P8_QUESTION_17: 'p8Question17',
  P8_QUESTION_18: 'p8Question18',
  P8_QUESTION_19: 'p8Question19',
  P8_QUESTION_20: 'p8Question20',

  P8_QUESTION_21: 'p8Question21',
  P8_QUESTION_22: 'p8Question22',
  P8_QUESTION_23: 'p8Question23',
  P8_QUESTION_24: 'p8Question24',
  P8_QUESTION_25: 'p8Question25',
  P8_QUESTION_26: 'p8Question26',
  P8_QUESTION_27: 'p8Question27',
  P8_QUESTION_28: 'p8Question28',
  P8_QUESTION_29: 'p8Question29',
  P8_QUESTION_30: 'p8Question30',

  P8_QUESTION_31: 'p8Question31',
  P8_QUESTION_32: 'p8Question32',
  P8_QUESTION_33: 'p8Question33',
  P8_QUESTION_34: 'p8Question34',
  P8_QUESTION_35: 'p8Question35',
  P8_QUESTION_36: 'p8Question36',
  P8_QUESTION_37: 'p8Question37',
  P8_QUESTION_38: 'p8Question38',
  P8_QUESTION_39: 'p8Question39',
  P8_QUESTION_40: 'p8Question40',

  P8_QUESTION_41: 'p8Question41',
  P8_QUESTION_42: 'p8Question42',
  P8_QUESTION_43: 'p8Question43',
  P8_QUESTION_44: 'p8Question44',
  P8_QUESTION_45: 'p8Question45',
  P8_QUESTION_46: 'p8Question46',
  P8_QUESTION_47: 'p8Question47',
  P8_QUESTION_48: 'p8Question48',
  P8_QUESTION_49: 'p8Question49',
  P8_QUESTION_50: 'p8Question50',

  P8_QUESTION_51: 'p8Question51',
  P8_QUESTION_52: 'p8Question52',
  P8_QUESTION_53: 'p8Question53',
  P8_QUESTION_54: 'p8Question54',
  P8_QUESTION_55: 'p8Question55',
  P8_QUESTION_56: 'p8Question56',
  P8_QUESTION_57: 'p8Question57',
  P8_QUESTION_58: 'p8Question58',
  P8_QUESTION_59: 'p8Question59',
  P8_QUESTION_60: 'p8Question60',

  P8_QUESTION_61: 'p8Question61',
  P8_QUESTION_62: 'p8Question62',
  P8_QUESTION_63: 'p8Question63',
  P8_QUESTION_64: 'p8Question64',
  P8_QUESTION_65: 'p8Question65',
  P8_QUESTION_66: 'p8Question66',
  P8_QUESTION_67: 'p8Question67',
  P8_QUESTION_68: 'p8Question68',
  P8_QUESTION_69: 'p8Question69',
  P8_QUESTION_70: 'p8Question70',

  P8_QUESTION_71: 'p8Question71',
  P8_QUESTION_72: 'p8Question72',
  P8_QUESTION_73: 'p8Question73',
  P8_QUESTION_74: 'p8Question74',
  P8_QUESTION_75: 'p8Question75',
  P8_QUESTION_76: 'p8Question76',
  P8_QUESTION_77: 'p8Question77',
  P8_QUESTION_78: 'p8Question78',
  P8_QUESTION_79: 'p8Question79',
  P8_QUESTION_80: 'p8Question80',

  P8_QUESTION_81: 'p8Question81',
  P8_QUESTION_82: 'p8Question82',
  P8_QUESTION_83: 'p8Question83',
  P8_QUESTION_84: 'p8Question84',
  P8_QUESTION_85: 'p8Question85',
  P8_QUESTION_86: 'p8Question86',
  P8_QUESTION_87: 'p8Question87'
};

export const Principle8Label = {
  P8_HEADING_1:
    'Businesses should promote inclusive growth and equitable development',
  P8_HEADINGLABEL_1: 'Essential Indicators',
  P8_HEADINGLABEL_2: 'Leadership Indicators',

  P8_QUESTION_1: `1. Details of Social Impact Assessments (SIA) of projects undertaken by the entity based on applicable laws, in the ${FY.current}.`,
  P8_QUESTION_2:
    '2. Provide information on project(s) for which ongoing Rehabilitation and Resettlement (R&R) is being undertaken by your entity, in the following format:',
  P8_QUESTION_3:
    '3. Describe the mechanisms to receive and redress grievances of the community.',
  P8_QUESTION_4:
    '4. Percentage of input material (inputs to total inputs by value) sourced from suppliers:',
  P8_QUESTION_5:
    '5. Job creation in smaller towns - Disclose wages paid to persons employed (including  employees or workers employed on a permanent or non-permanent / on contract basis) in the following locations, as % of total wage cost',
  P8_QUESTION_6:
    '1. Provide details of actions taken to mitigate any negative social impacts identified in the Social Impact Assessments (Reference: Question 1 of Essential Indicators above):',
  P8_QUESTION_7:
    '2. Provide the following information on CSR projects undertaken by your entity in designated aspirational districts as identified by government bodies:',
  P8_QUESTION_8:
    '3. a. Do you have a preferential procurement policy where you give preference to purchase from suppliers comprising marginalized /vulnerable groups? (Yes/No)',
  P8_QUESTION_9: `4. Details of the benefits derived and shared from the intellectual properties owned or acquired by your entity (in the ${FY.current}), based on traditional knowledge:`,
  P8_QUESTION_10:
    '5. Details of corrective actions taken or underway, based on any adverse order in intellectual property related disputes wherein usage of traditional knowledge is involved.',
  P8_QUESTION_11: '6. Details of beneficiaries of CSR Projects:',

  P8_HEADING_4: `In ( ${FY.current} )`,
  P8_HEADING_5: `In ( ${FY.previous} )`,

  P8_HEADING_6: 'Name and brief details of project',
  P8_HEADING_7: 'SIA Notification No.',
  P8_HEADING_8: 'Date of notification',
  P8_HEADING_9: 'Whether conducted by independent external agency (Yes / No)',
  P8_HEADING_10: 'Results communicated in public domain (Yes / No)',
  P8_HEADING_11: 'Relevant Web link',

  P8_HEADING_12: 'Name of Project for which R&R is ongoing',
  P8_HEADING_13: 'State',
  P8_HEADING_14: 'District',
  P8_HEADING_15: 'No. of Project Affected Families (PAFs)',
  P8_HEADING_16: '% of PAFs covered by R&R',
  P8_HEADING_17: 'Amounts paid to PAFs in the FY (In INR)',

  P8_HEADING_18: 'Directly sourced from MSMEs/ small producers',
  P8_HEADING_19:
    'Sourced directly from within the district and neighbouring districts',
  P8_HEADING_20: 'a. Rural',
  P8_HEADING_21: 'b. Semi-urban',
  P8_HEADING_22: 'c. Urban',
  P8_HEADING_23: 'd. Metropolitan',
  P8_HEADING_24:
    '(Place to be categorized as per RBI Classification System - rural / semi-urban / urban / metropolitan)',
  P8_HEADING_25: 'Location - ',

  P8_HEADING_26: 'Details of negative social impact identified',
  P8_HEADING_27: 'Corrective action taken',

  P8_HEADING_28: 'State',
  P8_HEADING_29: 'Aspirational District',
  P8_HEADING_30: 'Amount spent (In INR)',

  P8_HEADING_31: 'Intellectual Property based on traditional knowledge',
  P8_HEADING_32: 'Owned/ Acquired (Yes/No)',
  P8_HEADING_33: 'Benefit shared (Yes/No)',
  P8_HEADING_34: 'Basis of calculating benefit share',

  P8_HEADING_35: 'Name of authority',
  P8_HEADING_36: 'Brief of the Case',
  P8_HEADING_37: 'Corrective action taken',

  P8_HEADING_38: 'CSR Project',
  P8_HEADING_39: 'No. of persons benefitted from CSR Projects',
  P8_HEADING_40: '% of beneficiaries from vulnerable and marginalized groups',
  P8_HEADING_42:
    'b. From which marginalized /vulnerable groups do you procure?',
  P8_HEADING_43:
    'c. What percentage of total procurement (by value) does it constitute?',

  P8_LABEL_1: `In ( ${FY.current} )`,
  P8_LABEL_2: `In ( ${FY.previous} )`,
  P8_LABEL_3: 'N/A'
};

// principle9----------------------------------
export const Principle9Key = {
  P9_QUESTION_1: 'p9Question1',
  P9_QUESTION_2: 'p9Question2',
  P9_QUESTION_3: 'p9Question3',
  P9_QUESTION_4: 'p9Question4',
  P9_QUESTION_5: 'p9Question5',
  P9_QUESTION_6: 'p9Question6',
  P9_QUESTION_7: 'p9Question7',
  P9_QUESTION_8: 'p9Question8',
  P9_QUESTION_9: 'p9Question9',

  P9_QUESTION_10: 'p9Question10',
  P9_QUESTION_11: 'p9Question11',
  P9_QUESTION_12: 'p9Question12',
  P9_QUESTION_13: 'p9Question13',
  P9_QUESTION_14: 'p9Question14',
  P9_QUESTION_15: 'p9Question15',
  P9_QUESTION_16: 'p9Question16',
  P9_QUESTION_17: 'p9Question17',
  P9_QUESTION_18: 'p9Question18',
  P9_QUESTION_19: 'p9Question19',
  P9_QUESTION_20: 'p9Question20',

  P9_QUESTION_21: 'p9Question21',
  P9_QUESTION_22: 'p9Question22',
  P9_QUESTION_23: 'p9Question23',
  P9_QUESTION_24: 'p9Question24',
  P9_QUESTION_25: 'p9Question25',
  P9_QUESTION_26: 'p9Question26',
  P9_QUESTION_27: 'p9Question27',
  P9_QUESTION_28: 'p9Question28',
  P9_QUESTION_29: 'p9Question29',
  P9_QUESTION_30: 'p9Question30',

  P9_QUESTION_31: 'p9Question31',
  P9_QUESTION_32: 'p9Question32',
  P9_QUESTION_33: 'p9Question33',
  P9_QUESTION_34: 'p9Question34',
  P9_QUESTION_35: 'p9Question35',
  P9_QUESTION_36: 'p9Question36',
  P9_QUESTION_37: 'p9Question37',
  P9_QUESTION_38: 'p9Question38',
  P9_QUESTION_39: 'p9Question39',
  P9_QUESTION_40: 'p9Question40',

  P9_QUESTION_41: 'p9Question41',
  P9_QUESTION_42: 'p9Question42',
  P9_QUESTION_43: 'p9Question43',
  P9_QUESTION_44_1: 'p9Question44_1',
  P9_QUESTION_44: 'p9Question44',
  P9_QUESTION_45_1: 'p9Question45_1',
  P9_QUESTION_45: 'p9Question45',
  P9_QUESTION_46_1: 'p9Question46_1',
  P9_QUESTION_46: 'p9Question46',
  P9_QUESTION_47: 'p9Question47',
  P9_QUESTION_48: 'p9Question48',
  P9_QUESTION_49: 'p9Question49',
  P9_QUESTION_50: 'p9Question50',

  P9_QUESTION_51: 'p9Question51',
  P9_QUESTION_52: 'p9Question52',
  P9_QUESTION_53: 'p9Question53',
  P9_QUESTION_54: 'p9Question54',
  P9_QUESTION_55: 'p9Question55',
  P9_QUESTION_56: 'p9Question56',
  P9_QUESTION_57: 'p9Question57',
  P9_QUESTION_58: 'p9Question58',
  P9_QUESTION_59: 'p9Question59',
  P9_QUESTION_60: 'p9Question60',

  P9_QUESTION_61: 'p9Question61',
  P9_QUESTION_62: 'p9Question62',
  P9_QUESTION_63: 'p9Question63',
  P9_QUESTION_64: 'p9Question64',
  P9_QUESTION_65: 'p9Question65',
  P9_QUESTION_66: 'p9Question66',
  P9_QUESTION_67: 'p9Question67',
  P9_QUESTION_68: 'p9Question68',
  P9_QUESTION_69: 'p9Question69',
  P9_QUESTION_70: 'p9Question70',

  P9_QUESTION_71: 'p9Question71',
  P9_QUESTION_72: 'p9Question72',
  P9_QUESTION_73: 'p9Question73',
  P9_QUESTION_74: 'p9Question74',
  P9_QUESTION_75: 'p9Question75',
  P9_QUESTION_76: 'p9Question76',
  P9_QUESTION_77: 'p9Question77',
  P9_QUESTION_78: 'p9Question78',
  P9_QUESTION_79: 'p9Question79',
  P9_QUESTION_80: 'p9Question80',

  P9_QUESTION_81: 'p9Question81',
  P9_QUESTION_82: 'p9Question82',
  P9_QUESTION_83: 'p9Question83',
  P9_QUESTION_84: 'p9Question84',
  P9_QUESTION_85: 'p9Question85',
  P9_QUESTION_86_1: 'p9Question86_1',
  P9_QUESTION_86: 'p9Question86',
  P9_QUESTION_87: 'p9Question87',
  P9_QUESTION_88: 'p9Question88',
  P9_QUESTION_89: 'p9Question89',
  P9_QUESTION_90: 'p9Question90',

  P9_QUESTION_91: 'p9Question91',
  P9_QUESTION_92: 'p9Question92',
  P9_QUESTION_93: 'p9Question93',
  P9_QUESTION_94: 'p9Question94',
  P9_QUESTION_95: 'p9Question95',
  P9_QUESTION_96: 'p9Question96',
  P9_QUESTION_97: 'p9Question97',
  P9_QUESTION_98: 'p9Question98',
  P9_QUESTION_99: 'p9Question99',
  P9_QUESTION_100: 'p9Question100',

  P9_QUESTION_101: 'p9Question101',
  P9_QUESTION_102: 'p9Question102',
  P9_QUESTION_103: 'p9Question103',
  P9_QUESTION_104: 'p9Question104',
  P9_QUESTION_105: 'p9Question105',
  P9_QUESTION_106: 'p9Question106',
  P9_QUESTION_107: 'p9Question107',
  P9_QUESTION_108: 'p9Question108',
  P9_QUESTION_109: 'p9Question109',
  P9_QUESTION_110: 'p9Question110'
};

export const Principle9Label = {
  P9_HEADING_1:
    'Businesses should engage with and provide value to their consumers in a responsible manner',
  P9_HEADINGLABEL_1: 'Essential Indicators',
  P9_HEADINGLABEL_2: 'Leadership Indicators',

  P9_QUESTION_1:
    '1. Describe the mechanisms in place to receive and respond to consumer complaints and feedback.',
  P9_QUESTION_2:
    '2. Turnover of products and/ services as a percentage of turnover from all products/service that carry information about:',
  P9_QUESTION_3:
    '3. Number of consumer complaints in respect of the following:',
  P9_QUESTION_4:
    '4. Details of instances of product recalls on account of safety issues:',
  P9_QUESTION_5:
    '5. Does the entity have a framework/ policy on cyber security and risks related to data privacy? (Yes/No) If available, provide a web-link of the policy.',
  P9_QUESTION_6:
    '6. Provide details of any corrective actions taken or underway on issues relating to advertising, and  delivery of essential services. cyber security and data privacy of customers. re-occurrence of instances of product recalls. penalty  /  action taken by regulatory authorities on safety of products / services.',
  P9_QUESTION_7:
    '7. Provide the following information relating to data breaches:',
  P9_QUESTION_8:
    '1. Channels / platforms where information on products and services of the entity can be accessed (provide web link, if available).',
  P9_QUESTION_9:
    '2. Steps taken to inform and educate consumers  about safe and responsible usage of products and/or services.',
  P9_QUESTION_10:
    '3. Mechanisms in place to inform consumers of any risk of disruption/discontinuation of essential services.',
  P9_QUESTION_11:
    '4. Does the entity display product information on the product over and above what is mandated as per local laws? (Yes/No/Not Applicable) If yes, provide details in brief. Did your entity carry out any survey with regard to consumer satisfaction relating to the major products / services of the entity, significant locations of operation of the entity or the entity as a whole?',

  P9_HEADING_4: `In ( ${FY.current} )`,
  P9_HEADING_5: `In ( ${FY.previous} )`,

  P9_HEADING_6: 'Environmental and social parameters relevant to the product',
  P9_HEADING_7: 'Safe and responsible usage',
  P9_HEADING_8: 'Recycling and/or safe disposal',

  P9_HEADING_9: 'a. Data privacy',
  P9_HEADING_10: 'b. Advertising',
  P9_HEADING_11: 'c. Cyber-security',
  P9_HEADING_12: 'd. Delivery of essential services',
  P9_HEADING_13: 'e. Restrictive Trade Practices',
  P9_HEADING_14: 'f. Unfair Trade Practices',
  P9_HEADING_15: 'g. Other',

  P9_HEADING_16: 'Voluntary recalls',
  P9_HEADING_17: 'Forced recalls',

  P9_HEADING_18: 'a. Number of instances of data breaches',
  P9_HEADING_19:
    'b. Percentage of data breaches involving personally identifiable information of customers',
  P9_HEADING_20: 'c. Impact, if any, of the data breaches',

  P9_LABEL_1: `In ( ${FY.current} )`,
  P9_LABEL_2: `In ( ${FY.previous} )`,
  P9_LABEL_3: 'As a percentage to total turnover',

  P9_LABEL_4: 'Received during the year',
  P9_LABEL_5: 'Pending resolution at end of year',
  P9_LABEL_6: 'Remarks',

  P9_LABEL_7: 'Number',
  P9_LABEL_8: 'Reasons for recall',
  P9_LABEL_9: 'N/A'
};
